/**
 * Picará Doble - Frontend Interactive App
 * Handles Cart Drawer, Spicy Scale Filtering, Bundle Customizer, Quiz Matcher & Shopify Integration
 */

// Cart State
let cart = JSON.parse(localStorage.getItem('picaradoble_cart') || '[]');

// Shipping Threshold: $20.000 CLP for Free Shipping in RM
const FREE_SHIPPING_THRESHOLD = 20000;

// Format Currency
function formatCLP(amount) {
  return '$' + Number(amount || 0).toLocaleString('es-CL') + ' CLP';
}

// Check if running on Shopify live store or local Shopify CLI server
function isShopifyLive() {
  return typeof window.Shopify !== 'undefined' || 
         window.location.hostname.includes('myshopify.com') || 
         window.location.hostname.includes('picaradoble.com') ||
         window.location.port === '9292';
}

// Product Handle & Real Variant ID Map for Shopify Catalog (Store: ssj41n-sc.myshopify.com)
const SHOPIFY_HANDLE_MAP = {
  1: { handle: 'pack-del-sabor', variantId: 47732435058942, title: 'Pack Sr. Pecado + Pebre' },
  2: { handle: 'todos-los-pecados👹', variantId: 47814229426430, title: 'Pack de Salsas Picantes Macha | Sr. Pecado' },
  3: { handle: 'pack-de-camacho', variantId: 47396296196350, title: 'Pack De Camacho' },
  4: { handle: 'original-sr-pecado', variantId: 47517757833470, title: 'Salsa Picante Macha de Ají y Ajo Original - Sr. Pecado (🌶️ 3/7)' },
  5: { handle: 'lujuria-sr-pecado', variantId: 47518087676158, title: 'Salsa Macha de Avellanas y Castañas de Cajún | Lujuria - Sr. Pecado (🌶️ 1/7)' },
  6: { handle: 'inocente-sr-pecado', variantId: 47518306337022, title: 'Salsa Macha Suave de Maní y Ajo | Inocente - Sr. Pecado (🌶️ 2/7)' },
  7: { handle: 'caprichoso-sr-pecado', variantId: 47518408016126, title: 'Salsa Macha picante de Cebolla y Almendras | Caprichoso - Sr. Pecado (🌶️ 2/7)' },
  8: { handle: 'pebre-chileno-premium', variantId: 47396240982270, title: 'Pebre Chileno Premium (🌶️ 4/7)' },
  9: { handle: 'honey-bonnet-salsa-picante-aji-scotch-bonnet-y-miel', variantId: 47369943646462, title: 'Honey Bonnet - Salsa Picante Aji Scotch Bonnet y Miel (🌶️ 5/7)' },
  10: { handle: 'voodoo-prince-death-mamba-salsa-picante-aji-ghost-pepper', variantId: 47311998910718, title: 'Voodoo Prince Death Mamba - Salsa Picante Aji Ghost Pepper (🌶️ 7/7)' },
  11: { handle: 'gator-salsa-picante-aji-pepper-x', variantId: 47313497817342, title: 'Gator - Salsa Picante Aji Pepper X (🌶️ 8/7)' },

  // Shopify Product IDs mapping to Variant IDs (in case Liquid passes product.id)
  9117032972542: { handle: 'pack-del-sabor', variantId: 47732435058942, title: 'Pack Del Sabor' },
  9135830008062: { handle: 'todos-los-pecados👹', variantId: 47814229426430, title: 'Pack de Salsas Picantes Macha | Sr. Pecado' },
  9136412918014: { handle: 'pack-sabor-2', variantId: 47816761508094, title: 'Pack Sabor 2' },
  9016436752638: { handle: 'pack-de-camacho', variantId: 47396296196350, title: 'Pack De Camacho' },
  9056314949886: { handle: 'original-sr-pecado', variantId: 47517757833470, title: 'Salsa Picante Macha de Ají y Ajo Original - Sr. Pecado (🌶️ 3/7)' },
  9056315605246: { handle: 'lujuria-sr-pecado', variantId: 47518087676158, title: 'Salsa Macha de Avellanas y Castañas de Cajún | Lujuria - Sr. Pecado (🌶️ 1/7)' },
  9056317309182: { handle: 'inocente-sr-pecado', variantId: 47518306337022, title: 'Salsa Macha Suave de Maní y Ajo | Inocente - Sr. Pecado (🌶️ 2/7)' },
  9056317866238: { handle: 'caprichoso-sr-pecado', variantId: 47518408016126, title: 'Salsa Macha picante de Cebolla y Almendras | Caprichoso - Sr. Pecado (🌶️ 2/7)' },
  9016427544830: { handle: 'pebre-chileno-premium', variantId: 47396240982270, title: 'Pebre Chileno Premium (🌶️ 4/7)' },
  9002890297598: { handle: 'salsa-toro-diablo', variantId: 47345923752190, title: 'Salsa Toro Diablo (🌶️ 3/7)' },
  9002891280638: { handle: 'salsa-toro-loco', variantId: 47345925193982, title: 'Salsa Toro Loco (🌶️ 4/7)' },
  9009137582334: { handle: 'honey-bonnet-salsa-picante-aji-scotch-bonnet-y-miel', variantId: 47369943646462, title: 'Honey Bonnet - Salsa Picante Aji Scotch Bonnet y Miel (🌶️ 5/7)' },
  8999015645438: { handle: 'voodoo-prince-death-mamba-salsa-picante-aji-ghost-pepper', variantId: 47311998910718, title: 'Voodoo Prince Death Mamba - Salsa Picante Aji Ghost Pepper (🌶️ 7/7)' },
  8999064928510: { handle: 'gator-salsa-picante-aji-pepper-x', variantId: 47313497817342, title: 'Gator - Salsa Picante Aji Pepper X (🌶️ 8/7)' },
  
  // Aliases by handle string
  'original': { handle: 'original-sr-pecado', variantId: 47517757833470 },
  'original-sr-pecado': { handle: 'original-sr-pecado', variantId: 47517757833470 },
  'lujuria': { handle: 'lujuria-sr-pecado', variantId: 47518087676158 },
  'lujuria-sr-pecado': { handle: 'lujuria-sr-pecado', variantId: 47518087676158 },
  'inocente': { handle: 'inocente-sr-pecado', variantId: 47518306337022 },
  'inocente-sr-pecado': { handle: 'inocente-sr-pecado', variantId: 47518306337022 },
  'caprichoso': { handle: 'caprichoso-sr-pecado', variantId: 47518408016126 },
  'caprichoso-sr-pecado': { handle: 'caprichoso-sr-pecado', variantId: 47518408016126 },
  'pebre': { handle: 'pebre-chileno-premium', variantId: 47396240982270 },
  'pebre-chileno-premium': { handle: 'pebre-chileno-premium', variantId: 47396240982270 },
  'honey-bonnet': { handle: 'honey-bonnet-salsa-picante-aji-scotch-bonnet-y-miel', variantId: 47369943646462 },
  'honey-bonnet-salsa-picante-aji-scotch-bonnet-y-miel': { handle: 'honey-bonnet-salsa-picante-aji-scotch-bonnet-y-miel', variantId: 47369943646462 },
  'voodoo-prince': { handle: 'voodoo-prince-death-mamba-salsa-picante-aji-ghost-pepper', variantId: 47311998910718 },
  'voodoo-prince-death-mamba-salsa-picante-aji-ghost-pepper': { handle: 'voodoo-prince-death-mamba-salsa-picante-aji-ghost-pepper', variantId: 47311998910718 },
  'gator-pepper-x': { handle: 'gator-salsa-picante-aji-pepper-x', variantId: 47313497817342 },
  'gator-salsa-picante-aji-pepper-x': { handle: 'gator-salsa-picante-aji-pepper-x', variantId: 47313497817342 },
  'pack-del-sabor': { handle: 'pack-del-sabor', variantId: 47732435058942 },
  'pack-sr-pecado-pebre': { handle: 'pack-del-sabor', variantId: 47732435058942 },
  'pack-sabor-2': { handle: 'pack-sabor-2', variantId: 47816761508094 },
  'todos-los-pecados': { handle: 'todos-los-pecados👹', variantId: 47814229426430 },
  'todos-los-pecados👹': { handle: 'todos-los-pecados👹', variantId: 47814229426430 },
  'pack-todos-los-pecados': { handle: 'todos-los-pecados👹', variantId: 47814229426430 },
  'pack-de-camacho': { handle: 'pack-de-camacho', variantId: 47396296196350 },
  'salsa-toro-diablo': { handle: 'salsa-toro-diablo', variantId: 47345923752190 },
  'salsa-toro-loco': { handle: 'salsa-toro-loco', variantId: 47345925193982 }
};

// Catalog product prices map (dynamically hydrated from DOM and Shopify API)
const CATALOG_PRODUCT_PRICES = {
  'original-sr-pecado': 4990,
  'lujuria-sr-pecado': 4990,
  'inocente-sr-pecado': 4990,
  'caprichoso-sr-pecado': 4990,
  'pebre-chileno-premium': 3500,
  'salsa-toro-diablo': 3190,
  'salsa-toro-loco': 3190,
  'honey-bonnet-salsa-picante-aji-scotch-bonnet-y-miel': 19990,
  'voodoo-prince-death-mamba-salsa-picante-aji-ghost-pepper': 21990,
  'gator-salsa-picante-aji-pepper-x': 26990,
  'pack-del-sabor': 11990,
  'todos-los-pecados👹': 18990,
  'pack-sabor-2': 11990,
  'pack-de-camacho': 9390
};

function getProductCatalogPrice(handle, fallbackPrice = 0) {
  if (!handle) return fallbackPrice;

  // 1. Check in-memory catalog dictionary
  if (CATALOG_PRODUCT_PRICES[handle] && CATALOG_PRODUCT_PRICES[handle] > 0) {
    return CATALOG_PRODUCT_PRICES[handle];
  }

  // 2. Check DOM product cards
  const card = document.querySelector(`.product-card[data-product-handle="${handle}"]`);
  if (card) {
    const dataPrice = card.getAttribute('data-price');
    if (dataPrice && !isNaN(Number(dataPrice)) && Number(dataPrice) > 0) {
      CATALOG_PRODUCT_PRICES[handle] = Number(dataPrice);
      return Number(dataPrice);
    }
    const priceEl = card.querySelector('.product-price');
    if (priceEl && priceEl.textContent) {
      const parsed = Number(priceEl.textContent.replace(/[^0-9]/g, ''));
      if (!isNaN(parsed) && parsed > 0) {
        CATALOG_PRODUCT_PRICES[handle] = parsed;
        return parsed;
      }
    }
  }

  // 3. Check bundle row DOM
  const bundleRow = document.querySelector(`.bundle-sauce-row[data-handle="${handle}"]`);
  if (bundleRow) {
    const bPrice = bundleRow.getAttribute('data-price');
    if (bPrice && !isNaN(Number(bPrice)) && Number(bPrice) > 0) {
      CATALOG_PRODUCT_PRICES[handle] = Number(bPrice);
      return Number(bPrice);
    }
  }

  // 4. Check PACK_SAUCE_PRICES if available
  if (typeof PACK_SAUCE_PRICES !== 'undefined' && PACK_SAUCE_PRICES[handle] && PACK_SAUCE_PRICES[handle] > 0) {
    return PACK_SAUCE_PRICES[handle];
  }

  return fallbackPrice;
}

// Catalog ingredient badges for when product is in stock
const CATALOG_INGREDIENT_BADGES = {
  'original-sr-pecado': { text: 'MANÍ, AJO & AJÍ AHUMADO', className: 'product-badge-float badge-chester' },
  'lujuria-sr-pecado': { text: 'AVELLANAS, CAJÚ & ALMENDRAS', className: 'product-badge-float badge-green' },
  'inocente-sr-pecado': { text: 'MANÍ & AJÍ SUAVE', className: 'product-badge-float' },
  'caprichoso-sr-pecado': { text: 'CEBOLLA CARAMELIZADA & ALMENDRAS', className: 'product-badge-float badge-compact' },
  'salsa-toro-diablo': { text: 'AJÍ PUTA MADRE', className: 'product-badge-float badge-yellow' },
  'pebre-chileno-premium': { text: 'AJÍ CRISTAL & CACHO CABRA', className: 'product-badge-float badge-fire' },
  'salsa-toro-loco': { text: 'AJÍ ENCURTIDO (600K SHU)', className: 'product-badge-float badge-fire' },
  'honey-bonnet-salsa-picante-aji-scotch-bonnet-y-miel': { text: 'SCOTCH BONNET & MIEL', className: 'product-badge-float' },
  'voodoo-prince-death-mamba-salsa-picante-aji-ghost-pepper': { text: 'AJÍ GHOST PEPPER', className: 'product-badge-float badge-fire' },
  'gator-salsa-picante-aji-pepper-x': { text: '92% PEPPER X', className: 'product-badge-float badge-fire' }
};

// Manage Sold Out state for individual product cards in catalog
function applyCatalogCardSoldOut(card, isSoldOut) {
  if (!card) return;
  const footerBtn = card.querySelector('.product-card-footer button');
  let badge = card.querySelector('.product-badge-float');

  if (isSoldOut) {
    card.classList.add('sold-out');
    card.style.order = '99';

    if (!badge) {
      badge = document.createElement('span');
      card.prepend(badge);
    }
    if (!badge.dataset.origText && !badge.classList.contains('badge-soldout')) {
      badge.dataset.origText = badge.textContent.trim();
      badge.dataset.origClass = badge.className;
    }
    badge.className = 'product-badge-float badge-soldout';
    badge.textContent = 'AGOTADO';

    if (footerBtn) {
      footerBtn.textContent = 'Agotado';
      footerBtn.disabled = true;
      footerBtn.classList.add('btn-soldout');
    }

    // Ensure product-stock-notify-banner exists inside product-card-media
    const media = card.querySelector('.product-card-media');
    if (media && !media.querySelector('.product-stock-notify-banner')) {
      const handle = card.getAttribute('data-product-handle') || '';
      const titleLink = card.querySelector('.product-title a') || card.querySelector('.product-title');
      const title = titleLink ? titleLink.textContent.trim() : '';
      const imgEl = card.querySelector('.product-card-media img');
      const img = imgEl ? imgEl.src : '';
      const banner = document.createElement('div');
      banner.className = 'product-stock-notify-banner';
      banner.innerHTML = `
        <div class="notify-banner-inner">
          <span class="notify-banner-badge">⚠️ SIN STOCK TEMPORAL</span>
          <button type="button" class="btn-notify-banner"
            onclick="openStockNotifyModal('${handle}', '${title.replace(/'/g, "\\'")}', '${img}')">
            🔔 Avísenme cuando<br>esté disponible
          </button>
        </div>
      `;
      media.appendChild(banner);
    }

    const track = card.parentElement;
    if (track && track.classList.contains('catalog-carousel-track')) {
      track.appendChild(card);
    }
  } else {
    card.classList.remove('sold-out');
    card.classList.remove('is-notify-active');
    card.style.order = '';

    const handle = card.getAttribute('data-product-handle') || '';
    const ingBadge = CATALOG_INGREDIENT_BADGES[handle];

    if (badge && badge.dataset.origText) {
      badge.textContent = badge.dataset.origText;
      badge.className = badge.dataset.origClass || 'product-badge-float';
    } else if (ingBadge) {
      if (!badge) {
        badge = document.createElement('span');
        card.prepend(badge);
      }
      badge.textContent = ingBadge.text;
      badge.className = ingBadge.className;
    } else if (badge && badge.classList.contains('badge-soldout')) {
      badge.remove();
    }

    if (footerBtn) {
      footerBtn.textContent = '+ Agregar';
      footerBtn.disabled = false;
      footerBtn.classList.remove('btn-soldout');
    }
  }
}
window.applyCatalogCardSoldOut = applyCatalogCardSoldOut;

function initCatalogPricesFromDOM() {
  document.querySelectorAll('.product-card[data-product-handle]').forEach(card => {
    const handle = card.getAttribute('data-product-handle');
    const priceAttr = card.getAttribute('data-price');
    const availAttr = card.getAttribute('data-available');

    if (handle && priceAttr) {
      const p = Number(priceAttr);
      if (!isNaN(p) && p > 0) {
        CATALOG_PRODUCT_PRICES[handle] = p;
        if (typeof PACK_SAUCE_PRICES !== 'undefined' && (PACK_SAUCE_PRICES[handle] || (typeof ELIGIBLE_BUNDLE_SAUCES !== 'undefined' && ELIGIBLE_BUNDLE_SAUCES[handle]))) {
          PACK_SAUCE_PRICES[handle] = p;
        }
      }
    }

    if (availAttr === 'false') {
      applyCatalogCardSoldOut(card, true);
    } else if (availAttr === 'true') {
      applyCatalogCardSoldOut(card, false);
    }
  });
}

// Hover and touch interaction for sold out product notify banner
function initStockNotifyHover() {
  const cards = document.querySelectorAll('.product-card');
  cards.forEach(card => {
    const media = card.querySelector('.product-card-media');
    const title = card.querySelector('.product-title');
    const banner = card.querySelector('.product-stock-notify-banner');

    const handleEnter = () => {
      if (card.classList.contains('sold-out')) {
        card.classList.add('is-notify-active');
      }
    };

    const handleLeave = (e) => {
      if (e && e.relatedTarget && card.contains(e.relatedTarget)) {
        return;
      }
      card.classList.remove('is-notify-active');
    };

    if (media) {
      media.addEventListener('mouseenter', handleEnter);
      media.addEventListener('mouseleave', handleLeave);
    }
    if (title) {
      title.addEventListener('mouseenter', handleEnter);
      title.addEventListener('mouseleave', handleLeave);
    }
    if (banner) {
      banner.addEventListener('mouseenter', handleEnter);
      banner.addEventListener('mouseleave', handleLeave);
    }
    card.addEventListener('mouseleave', handleLeave);

    // Mobile / touch screen tap toggle
    const handleTouchToggle = (e) => {
      if (!card.classList.contains('sold-out')) return;
      if (e.target.closest('.btn-notify-banner')) return;

      const wasActive = card.classList.contains('is-notify-active');
      document.querySelectorAll('.product-card.is-notify-active').forEach(c => {
        if (c !== card) c.classList.remove('is-notify-active');
      });
      if (!wasActive) {
        card.classList.add('is-notify-active');
      } else {
        card.classList.remove('is-notify-active');
      }
    };

    if (media) media.addEventListener('click', handleTouchToggle);
    if (title) title.addEventListener('click', handleTouchToggle);
  });

  // Global touch / click outside dismisses active banners
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.product-card.sold-out')) {
      document.querySelectorAll('.product-card.is-notify-active').forEach(c => {
        c.classList.remove('is-notify-active');
      });
    }
  });
}
window.initStockNotifyHover = initStockNotifyHover;

// Cache for resolved variant IDs
const variantIdCache = {};

async function resolveShopifyVariantId(id, handleOrVariantId) {
  // 1. Check direct map (handles IDs, numbers, strings, and product IDs)
  if (id && SHOPIFY_HANDLE_MAP[id] && SHOPIFY_HANDLE_MAP[id].variantId) {
    return SHOPIFY_HANDLE_MAP[id].variantId;
  }
  if (handleOrVariantId && SHOPIFY_HANDLE_MAP[handleOrVariantId] && SHOPIFY_HANDLE_MAP[handleOrVariantId].variantId) {
    return SHOPIFY_HANDLE_MAP[handleOrVariantId].variantId;
  }

  // 2. Check if already a genuine Shopify variant ID (variants are in the ~47e12 range)
  if (typeof handleOrVariantId === 'number' && handleOrVariantId >= 40000000000000 && handleOrVariantId < 90000000000000) {
    return handleOrVariantId;
  }
  if (typeof id === 'number' && id >= 40000000000000 && id < 90000000000000) {
    return id;
  }

  // 3. Fallback lookup via Shopify Product AJAX API
  const lookupHandle = (typeof handleOrVariantId === 'string' ? handleOrVariantId : '') ||
                       (SHOPIFY_HANDLE_MAP[id] && SHOPIFY_HANDLE_MAP[id].handle) ||
                       (typeof id === 'string' ? id : null);
  if (!lookupHandle) return null;
  if (variantIdCache[lookupHandle]) return variantIdCache[lookupHandle];

  try {
    const res = await fetch(`/products/${encodeURIComponent(lookupHandle)}.js`);
    if (res.ok) {
      const data = await res.json();
      if (data && data.variants && data.variants.length > 0) {
        const variantId = data.variants[0].id;
        variantIdCache[lookupHandle] = variantId;
        return variantId;
      }
    }
  } catch (err) {
    console.warn('[Shopify API] Could not fetch product info for handle:', lookupHandle, err);
  }
  return null;
}

// Show Toast Notification (Defensive Null Check)
function showToast(message) {
  const toastNotice = document.getElementById('toast-notice');
  const toastText = document.getElementById('toast-text');
  if (toastText) toastText.textContent = message;
  if (toastNotice) {
    toastNotice.classList.add('show');
    setTimeout(() => {
      toastNotice.classList.remove('show');
    }, 2800);
  }
}

// Cart Drawer Controls (Defensive Null Check)
function openCart(e) {
  if (e && typeof e.preventDefault === 'function') {
    e.preventDefault();
  }
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  if (cartDrawerOverlay) {
    cartDrawerOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  renderCart();
  updateBadge();
}

function closeCart() {
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  if (cartDrawerOverlay) {
    cartDrawerOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
}

// Mobile Nav Persiana Controls with Debounce Lock
let navToggleLock = false;

function toggleMobileNav(event) {
  if (event) {
    if (typeof event.preventDefault === 'function') event.preventDefault();
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }

  if (navToggleLock) return;
  navToggleLock = true;
  setTimeout(() => { navToggleLock = false; }, 300);

  const dropdowns = Array.from(document.querySelectorAll('.mobile-nav-dropdown'));
  // Buscar el dropdown visible en pantalla (evitar header oculto de Dawn header group)
  const visibleDropdown = dropdowns.find(d => !d.closest('.shopify-section-group-header-group')) || dropdowns[0];
  const isOpen = visibleDropdown && (visibleDropdown.classList.contains('open') || visibleDropdown.style.visibility === 'visible');

  if (isOpen) {
    closeMobileNav(event);
  } else {
    openMobileNav(event);
  }
}
window.toggleMobileNav = toggleMobileNav;

function openMobileNav(event) {
  if (event) {
    if (typeof event.preventDefault === 'function') event.preventDefault();
    if (typeof event.stopPropagation === 'function') event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
  }

  const dropdowns = document.querySelectorAll('.mobile-nav-dropdown, #mobile-nav-dropdown');
  const backdrops = document.querySelectorAll('.mobile-nav-backdrop, #mobile-nav-backdrop');
  const buttons = document.querySelectorAll('.mobile-menu-btn, #mobile-menu-trigger-btn');
  const headers = document.querySelectorAll('.site-header, #main-header');

  if (dropdowns.length > 0) {
    dropdowns.forEach(d => {
      d.classList.add('open');
      d.style.maxHeight = 'calc(100vh - 70px)';
      d.style.opacity = '1';
      d.style.visibility = 'visible';
    });
    backdrops.forEach(b => {
      b.classList.add('open');
      b.style.opacity = '1';
      b.style.visibility = 'visible';
      b.style.pointerEvents = 'auto';
    });
    buttons.forEach(btn => {
      btn.classList.add('is-active');
      btn.setAttribute('aria-expanded', 'true');
    });
    headers.forEach(h => h.classList.add('nav-open'));
    document.body.classList.add('mobile-nav-open');
    return;
  }

  // Fallback for legacy drawer overlay if still present
  const overlays = document.querySelectorAll('.mobile-nav-drawer-overlay, #mobile-nav-overlay');
  if (overlays.length > 0) {
    overlays.forEach(overlay => overlay.classList.add('open'));
    document.body.style.overflow = 'hidden';
  }
}
window.openMobileNav = openMobileNav;

function closeMobileNav(event) {
  // Do NOT call event.preventDefault() so anchor links can navigate naturally
  const dropdowns = document.querySelectorAll('.mobile-nav-dropdown, #mobile-nav-dropdown');
  const backdrops = document.querySelectorAll('.mobile-nav-backdrop, #mobile-nav-backdrop');
  const buttons = document.querySelectorAll('.mobile-menu-btn, #mobile-menu-trigger-btn');
  const headers = document.querySelectorAll('.site-header, #main-header');

  if (dropdowns.length > 0) {
    dropdowns.forEach(d => {
      d.classList.remove('open');
      d.style.maxHeight = '';
      d.style.opacity = '';
      d.style.visibility = '';
    });
    backdrops.forEach(b => {
      b.classList.remove('open');
      b.style.opacity = '';
      b.style.visibility = '';
      b.style.pointerEvents = '';
    });
    buttons.forEach(btn => {
      btn.classList.remove('is-active');
      btn.setAttribute('aria-expanded', 'false');
    });
    headers.forEach(h => h.classList.remove('nav-open'));
    document.body.classList.remove('mobile-nav-open');
  }

  // Fallback for legacy drawer overlay
  const overlays = document.querySelectorAll('.mobile-nav-drawer-overlay, #mobile-nav-overlay');
  if (overlays.length > 0) {
    overlays.forEach(overlay => overlay.classList.remove('open'));
    document.body.style.overflow = '';
  }
}
window.closeMobileNav = closeMobileNav;

function handleMobileNavLinkClick(event) {
  const link = event ? (event.currentTarget || (event.target && event.target.closest('a'))) : null;
  if (!link) {
    closeMobileNav();
    return;
  }

  const href = link.getAttribute('href');
  if (!href) {
    closeMobileNav();
    return;
  }

  // 1. Cerrar persiana de inmediato
  closeMobileNav();

  // 2. Comprobar si es un enlace a una sección interna (#seccion o /#seccion en la home)
  const hashIndex = href.indexOf('#');
  if (hashIndex !== -1) {
    const targetPath = href.substring(0, hashIndex);
    const targetHash = href.substring(hashIndex);
    const isHomePage = window.location.pathname === '/' || window.location.pathname === '';

    if (targetPath === '' || (isHomePage && (targetPath === '/' || targetPath === window.location.pathname))) {
      const targetEl = document.querySelector(targetHash);
      if (targetEl) {
        if (event && typeof event.preventDefault === 'function') event.preventDefault();
        setTimeout(() => {
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
        if (window.history && window.history.pushState) {
          window.history.pushState(null, null, targetHash);
        }
        return;
      }
    }
  }
  // Para enlaces externos o a otras páginas (ej. desde /products a /#arma-tu-pack o Instagram), dejar que el navegador navegue normalmente
}
window.handleMobileNavLinkClick = handleMobileNavLinkClick;

// Add To Cart with Live Shopify Ajax Cart Synchronization
async function addToCart(id, title, price, image, handleOrVariantId, properties = null, originalPrice = null) {
  const isCustomPack = properties && (properties['_pack_chester'] === 'true' || properties['Pack']);
  const isQuizMatch = properties && (properties['_quiz_match'] === 'true' || properties['Match']);
  
  // Gatekeeper: Evitar agregar salsas individuales agotadas
  const sauceHandle = typeof handleOrVariantId === 'string' ? handleOrVariantId : (SHOPIFY_HANDLE_MAP[id]?.handle || '');
  if (sauceHandle && !isCustomPack) {
    const card = document.querySelector(`.product-card[data-product-handle="${sauceHandle}"]`);
    if (card && (card.classList.contains('sold-out') || card.getAttribute('data-available') === 'false')) {
      showToast(`⚠️ "${title.split('(')[0].trim()}" se encuentra temporalmente agotado.`, 'warning');
      return;
    }
  }

  // Resolve real variant ID first for reliable tracking
  const realVariantId = await resolveShopifyVariantId(id, handleOrVariantId);
  const cartItemId = realVariantId ? (isCustomPack ? (realVariantId + '_' + (properties['_bundle_id'] || Date.now())) : realVariantId) : id;

  const existingItem = cart.find(item => {
    const itemIsPack = item.properties && (item.properties['_pack_chester'] === 'true' || item.properties['Pack']);
    const itemIsQuiz = item.properties && (item.properties['_quiz_match'] === 'true' || item.properties['Match']);
    if (itemIsPack || itemIsQuiz) return false;
    if (isCustomPack || isQuizMatch) return false;

    return (
      item.id === cartItemId || 
      item.id === id || 
      (realVariantId && item.variantId === realVariantId) ||
      (item.handle && handleOrVariantId && item.handle === handleOrVariantId)
    );
  });

  if (existingItem) {
    existingItem.qty += 1;
  } else {
    cart.push({
      id: cartItemId,
      key: String(cartItemId),
      variantId: realVariantId || (typeof id === 'number' && id > 100000000 ? id : null),
      title,
      price: Number(price),
      originalPrice: originalPrice ? Number(originalPrice) : Number(price),
      image,
      handle: typeof handleOrVariantId === 'string' ? handleOrVariantId : (SHOPIFY_HANDLE_MAP[id]?.handle || ''),
      qty: 1,
      properties: properties || {}
    });
  }
  saveCart();
  renderCart();
  showToast(`¡${title} agregado al carrito! 🔥`);
  openCart();

  // Synchronize with Shopify Backend Cart
  if (isShopifyLive()) {
    try {
      const variantIdToSync = realVariantId || await resolveShopifyVariantId(id, handleOrVariantId);
      if (variantIdToSync) {
        const payloadItem = {
          id: Number(variantIdToSync),
          quantity: 1
        };
        if (properties) {
          payloadItem.properties = properties;
        }
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [payloadItem]
          })
        });

        if (response.ok) {
          console.log('[Shopify Cart] Item synchronized successfully:', title, variantIdToSync);
          await syncFromShopifyBackend();
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        } else {
          const errText = await response.text();
          console.warn('[Shopify Cart Error] Response not OK:', errText);

          // Rollback local cart addition if backend rejected (e.g. out of stock)
          const addedIndex = cart.findIndex(item => item.id === cartItemId || item.key === String(cartItemId));
          if (addedIndex !== -1) {
            if (cart[addedIndex].qty > 1) {
              cart[addedIndex].qty -= 1;
            } else {
              cart.splice(addedIndex, 1);
            }
            saveCart();
            renderCart();
            updateBadge();
          }
          showToast('⚠️ No se pudo agregar: producto sin stock disponible.', 'error');
        }
      }
    } catch (e) {
      console.warn('[Shopify Cart Sync Error]', e);
    }
  }
}

// Add Quiz Match Item to Cart with 10% OFF
async function addQuizMatchToCart(id, title, originalPrice, discountedPrice, image, handle) {
  const matchProperties = {
    '_quiz_match': 'true',
    'Match': 'Match Chester 10% OFF'
  };
  await addToCart(id, title, discountedPrice, image, handle, matchProperties, originalPrice);
}

// Direct Buy Now
async function buyNow(id, title, price, image, handleOrVariantId) {
  await addToCart(id, title, price, image, handleOrVariantId);
  checkoutRedirect();
}

// 1-Click In-Cart Upsell Handler
async function addUpsellProduct(handle, variantId, title, price, image) {
  const card = document.querySelector(`.product-card[data-product-handle="${handle}"]`);
  if (card && (card.classList.contains('sold-out') || card.getAttribute('data-available') === 'false')) {
    showToast(`⚠️ "${title}" se encuentra temporalmente agotado.`, 'warning');
    const upsellSection = document.getElementById('cart-upsell-section');
    if (upsellSection) upsellSection.style.display = 'none';
    return;
  }
  await addToCart(variantId, title, price, image, handle);
  const upsellSection = document.getElementById('cart-upsell-section');
  if (upsellSection) {
    const btn = upsellSection.querySelector('.btn-upsell-add');
    if (btn) {
      btn.textContent = '✓ ¡Agregado!';
      btn.style.backgroundColor = 'var(--brand-green)';
      btn.disabled = true;
      setTimeout(() => {
        btn.textContent = '+ Agregar';
        btn.style.backgroundColor = 'var(--brand-red)';
        btn.disabled = false;
      }, 2000);
    }
  }
}

// Update Cart Quantity
async function updateQty(id, delta) {
  const item = cart.find(item => String(item.id) === String(id));
  if (!item) return;
  item.qty += delta;
  const newQty = item.qty;
  if (item.qty <= 0) {
    cart = cart.filter(i => String(i.id) !== String(id));
  }
  saveCart();
  renderCart();

  if (isShopifyLive() && item) {
    try {
      const lineItemKey = item.key || item.id;
      if (lineItemKey && lineItemKey !== 'undefined') {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: String(lineItemKey),
            quantity: Math.max(0, newQty)
          })
        });
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (e) {
      console.warn('[Shopify Cart Change Error]', e);
    }
  }
}

// Remove from Cart
async function removeFromCart(id) {
  const item = cart.find(item => String(item.id) === String(id));
  cart = cart.filter(i => String(i.id) !== String(id));
  saveCart();
  renderCart();

  if (isShopifyLive() && item) {
    try {
      const lineItemKey = item.key || item.id;
      if (lineItemKey && lineItemKey !== 'undefined') {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: String(lineItemKey),
            quantity: 0
          })
        });
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (e) {
      console.warn('[Shopify Cart Remove Error]', e);
    }
  }
}

// Save Cart
function saveCart() {
  localStorage.setItem('picaradoble_cart', JSON.stringify(cart));
  if (cart.length === 0) {
    localStorage.removeItem('picaradoble_active_discount');
  }
  updateBadge();
}

// Update Badges across all locations
function updateBadge() {
  const totalCount = cart.reduce((sum, item) => sum + (Number(item.qty) || 0), 0);
  const badges = document.querySelectorAll('#cart-count-badge, #bottom-cart-badge, .cart-count-badge, [data-cart-count], .cart-count-bubble span');
  badges.forEach(badge => {
    badge.textContent = String(totalCount);
  });
}

// Update Shipping Bar
function updateShippingBar(subtotal) {
  const shippingStatusText = document.getElementById('shipping-status-text');
  const shippingPercentText = document.getElementById('shipping-percent-text');
  const shippingBarFill = document.getElementById('shipping-bar-fill');

  const percent = Math.min(100, Math.round((subtotal / FREE_SHIPPING_THRESHOLD) * 100));
  if (shippingBarFill) shippingBarFill.style.width = percent + '%';
  if (shippingPercentText) shippingPercentText.textContent = percent + '%';

  const remaining = FREE_SHIPPING_THRESHOLD - subtotal;
  if (shippingStatusText) {
    if (subtotal === 0) {
      shippingStatusText.innerHTML = `🚛 ¡Agrega <strong>${formatCLP(FREE_SHIPPING_THRESHOLD)}</strong> para Envío Gratis en RM!`;
      if (shippingBarFill) shippingBarFill.style.backgroundColor = 'var(--brand-yellow-warm)';
    } else if (remaining <= 0) {
      shippingStatusText.innerHTML = '🎉 <strong>¡FELICITACIONES! Tienes Envío Gratis en RM</strong>';
      if (shippingBarFill) shippingBarFill.style.backgroundColor = 'var(--brand-green)';
    } else {
      shippingStatusText.innerHTML = `🚛 ¡Agrega <strong>${formatCLP(remaining)}</strong> para Envío Gratis en RM!`;
      if (shippingBarFill) shippingBarFill.style.backgroundColor = 'var(--brand-yellow-warm)';
    }
  }
}

// Render Cart Drawer
function renderCart() {
  updateBadge();
  const cartItemsList = document.getElementById('cart-items-list');
  const cartSubtotalAmount = document.getElementById('cart-subtotal-amount');
  if (!cartItemsList) return;

  if (cart.length === 0) {
    cartItemsList.innerHTML = `
      <div style="text-align: center; padding: 3rem 1rem; color: #888;">
        <div style="font-size: 3rem; margin-bottom: 0.8rem;">🌶️</div>
        <p style="font-family: var(--font-heading-heavy); font-size: 1.2rem; color: var(--brand-black); text-transform: uppercase;">
          Tu carrito está vacío Chester
        </p>
        <p style="font-size: 0.9rem; margin-top: 0.4rem;">
          ¡Agrega tus salsas o packs favoritos para empezar a disfrutar!
        </p>
      </div>
    `;
    if (cartSubtotalAmount) cartSubtotalAmount.textContent = '$0 CLP';
    updateShippingBar(0);
    return;
  }

  // Separar grupos de packs personalizados vs ítems normales / packs curados
  const bundleGroups = {};
  const standalonePackItems = [];
  const normalItems = [];

  for (const item of cart) {
    const isCustomPack = item.properties && (item.properties['_pack_chester'] === 'true' || item.properties['Pack']);
    const bundleId = item.properties && (item.properties['_bundle_id'] || item.properties['BundleID']);

    if (isCustomPack && bundleId) {
      if (!bundleGroups[bundleId]) bundleGroups[bundleId] = [];
      bundleGroups[bundleId].push(item);
    } else if (isCustomPack) {
      standalonePackItems.push(item);
    } else {
      normalItems.push(item);
    }
  }

  // Si hay packs antiguos sin _bundle_id, agruparlos juntos
  if (standalonePackItems.length > 0) {
    bundleGroups['legacy_bundle'] = standalonePackItems;
  }

  let subtotal = 0;
  let html = '';

  // Renderizar cada pack personalizado como un grupo visual independiente
  for (const [bundleId, bItems] of Object.entries(bundleGroups)) {
    const packCount = bItems.reduce((sum, item) => sum + (Number(item.qty) || 1), 0);
    const packDiscountPercent = Math.round(getDiscountPercentForCount(packCount) * 100);
    const packFullPrice = bItems.reduce((sum, item) => sum + ((item.originalPrice || item.price || 0) * (item.qty || 1)), 0);
    const packFinalPrice = bItems.reduce((sum, item) => sum + ((item.finalPrice || item.price || 0) * (item.qty || 1)), 0);
    const packSaved = packFullPrice - packFinalPrice;

    html += `
      <div class="cart-pack-group">
        <div class="cart-pack-header">
          <span class="cart-pack-title">
            🌶️ Pack Chester x${packCount}
          </span>
          ${packDiscountPercent > 0 ? `<span class="cart-pack-discount-pill">-${packDiscountPercent}% OFF</span>` : ''}
        </div>
    `;

    for (const item of bItems) {
      const displayPrice = item.finalPrice || item.price || 0;
      subtotal += displayPrice * (item.qty || 1);
      const itemIdParam = typeof item.id === 'string' ? `'${item.id}'` : item.id;
      const hasDiscount = item.originalPrice && item.finalPrice && item.originalPrice > item.finalPrice;

      html += `
        <div class="cart-item" style="border-bottom: 1px solid #f0f0f0; margin-bottom: 0.25rem;">
          <img src="${item.image}" alt="${item.title}" class="cart-item-img">
          <div class="cart-item-details">
            <div class="cart-item-title">${item.title}</div>
            <div class="cart-item-price">
              ${hasDiscount ? `<span style="text-decoration: line-through; color: #999; font-size: 0.75rem; margin-right: 4px;">${formatCLP(item.originalPrice)}</span>` : ''}
              ${formatCLP(displayPrice)}
            </div>
            <div class="cart-item-qty-row">
              <button class="cart-qty-btn" onclick="updateQty(${itemIdParam}, -1)">−</button>
              <span class="cart-qty-num">${item.qty}</span>
              <button class="cart-qty-btn" onclick="updateQty(${itemIdParam}, 1)">+</button>
              <button class="cart-remove-btn" onclick="removeFromCart(${itemIdParam})">Eliminar</button>
            </div>
          </div>
        </div>
      `;
    }

    if (packSaved > 0) {
      html += `
        <div style="text-align: center; padding: 0.25rem 0.5rem; margin-top: 0.35rem; background: var(--brand-green); color: white; border-radius: 6px; font-family: var(--font-subhead); font-size: 0.72rem; font-weight: 700;">
          🎉 Ahorras ${formatCLP(packSaved)} con este Pack Chester
        </div>
      `;
    }

    html += `</div>`;
  }

  // Renderizar ítems normales (no-pack)
  for (const item of normalItems) {
    const isQuizMatch = item.properties && (item.properties['_quiz_match'] === 'true' || item.properties['Match']);
    const origPrice = item.originalPrice || (isQuizMatch && item.price ? Math.round(item.price / 0.9) : item.price) || 0;
    const unitPrice = isQuizMatch ? (item.price < origPrice ? item.price : Math.round(origPrice * 0.9)) : (item.price || 0);
    const itemTotal = unitPrice * (item.qty || 1);
    subtotal += itemTotal;
    const itemIdParam = typeof item.id === 'string' ? `'${item.id}'` : item.id;
    const hasDiscount = isQuizMatch || (origPrice > unitPrice);

    html += `
      <div class="cart-item">
        <img src="${item.image}" alt="${item.title}" class="cart-item-img">
        <div class="cart-item-details">
          <div class="cart-item-title">
            ${isQuizMatch ? `<span class="cart-match-badge" style="background: var(--brand-red); color: #fff; font-size: 0.68rem; font-family: var(--font-subhead); padding: 2px 6px; border-radius: 4px; display: inline-block; margin-bottom: 3px;">🎯 MATCH CHESTER (-10%)</span><br>` : ''}
            ${item.title}
          </div>
          <div class="cart-item-price">
            ${hasDiscount ? `<span style="text-decoration: line-through; color: #999; font-size: 0.8rem; margin-right: 4px;">${formatCLP(origPrice)}</span>` : ''}
            ${formatCLP(unitPrice)}
          </div>
          <div class="cart-item-qty-row">
            <button class="cart-qty-btn" onclick="updateQty(${itemIdParam}, -1)">−</button>
            <span class="cart-qty-num">${item.qty}</span>
            <button class="cart-qty-btn" onclick="updateQty(${itemIdParam}, 1)">+</button>
            <button class="cart-remove-btn" onclick="removeFromCart(${itemIdParam})">Eliminar</button>
          </div>
        </div>
      </div>
    `;
  }

  cartItemsList.innerHTML = html;
  if (cartSubtotalAmount) cartSubtotalAmount.textContent = formatCLP(subtotal);
  updateShippingBar(subtotal);
}

// Checkout Redirect (Automatic Tiered Discount applied by Shopify Functions + Quiz Match Coupon)
async function checkoutRedirect() {
  if (cart.length === 0) {
    showToast('Tu carrito está vacío. ¡Agrega salsas antes de pagar!');
    return;
  }

  const hasQuizMatch = cart.some(item => 
    item.properties && (item.properties['_quiz_match'] === 'true' || item.properties['Match'])
  );

  if (isShopifyLive()) {
    showToast('Cargando pago seguro con Webpay y Mercado Pago... 🔒');

    // Pre-sync verification to ensure backend cart has all items before redirect
    try {
      const res = await fetch('/cart.js');
      if (res.ok) {
        const liveCart = await res.json();
        if (liveCart.items.length === 0 && cart.length > 0) {
          const itemsPayload = [];
          for (const item of cart) {
            const vId = item.variantId || await resolveShopifyVariantId(item.id, item.handle);
            if (vId) {
              itemsPayload.push({
                id: Number(vId),
                quantity: item.qty || 1,
                properties: item.properties || {}
              });
            }
          }
          if (itemsPayload.length > 0) {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: itemsPayload })
            });
          }
        }
      }
    } catch (err) {
      console.warn('[Checkout Pre-sync]', err);
    }

    const appliedDiscount = localStorage.getItem('picara_applied_discount');
    if (hasQuizMatch) {
      window.location.href = '/discount/MATCH10?redirect=/checkout';
    } else if (appliedDiscount === 'CATADORVIP') {
      window.location.href = '/discount/CATADORVIP?redirect=/checkout';
    } else {
      window.location.href = '/checkout';
    }
  } else {
    const appliedDiscount = localStorage.getItem('picara_applied_discount');
    let discountParam = '';
    let discountMsg = '';
    if (hasQuizMatch) {
      discountParam = '/discount/MATCH10';
      discountMsg = '\n🎯 ¡Cupón MATCH10 aplicado para tu salsa recomendada!\n';
    } else if (appliedDiscount === 'CATADORVIP') {
      discountParam = '/discount/CATADORVIP';
      discountMsg = '\n⭐ ¡Cupón CATADORVIP (15% OFF) aplicado para tu pedido!\n';
    }
    const targetUrl = discountParam 
      ? `https://ssj41n-sc.myshopify.com${discountParam}?redirect=/checkout` 
      : 'https://ssj41n-sc.myshopify.com/checkout';
    const proceed = confirm(`🛒 Picará Doble - Redirección a Pago Seguro Shopify\n\nTotal estimado: ${document.getElementById('cart-subtotal-amount')?.textContent || '$0 CLP'}${discountMsg}\n¿Deseas abrir la tienda online para probar el checkout real?`);
    if (proceed) {
      window.open(targetUrl, '_blank');
    }
  }
}

// ----------------------------------------------------
// PACKS CAROUSEL NAVIGATION (MOBILE)
// ----------------------------------------------------
function scrollPacksCarousel(direction) {
  const track = document.getElementById('main-packs-grid') || document.querySelector('.pack-poster-grid');
  if (!track) return;
  const card = track.querySelector('.poster-card');
  const cardWidth = card ? card.offsetWidth + 20 : 290;
  track.scrollBy({
    left: direction * cardWidth,
    behavior: 'smooth'
  });
}

// ----------------------------------------------------
// CATALOG CAROUSEL NAVIGATION
// ----------------------------------------------------
function scrollCatalogCarousel(direction) {
  const track = document.getElementById('main-product-grid');
  if (!track) return;
  const card = track.querySelector('.product-card');
  const cardWidth = card ? card.offsetWidth + 25 : 300;
  track.scrollBy({
    left: direction * cardWidth * (window.innerWidth < 768 ? 1 : 2),
    behavior: 'smooth'
  });
}

// ----------------------------------------------------
// SPICE METER FILTERING
// ----------------------------------------------------
function initSpiceFilters() {
  const spiceFilterButtons = document.querySelectorAll('.spice-btn');
  const productCards = document.querySelectorAll('.product-card');
  const track = document.getElementById('main-product-grid');

  spiceFilterButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      spiceFilterButtons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const filter = btn.getAttribute('data-spice');

      productCards.forEach(card => {
        const cardSpice = parseInt(card.getAttribute('data-spice-lvl') || '0', 10);
        if (filter === 'all') {
          card.style.display = 'flex';
        } else if (filter === '5') {
          card.style.display = cardSpice >= 5 ? 'flex' : 'none';
        } else {
          card.style.display = cardSpice === parseInt(filter, 10) ? 'flex' : 'none';
        }
      });

      if (track) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      }
    });
  });
}

// ----------------------------------------------------
// BUNDLE BUILDER ("Arma tu Pack Chester")
// ----------------------------------------------------
let bundleSelections = [];
const MAX_BUNDLE_ITEMS = 6;

// Metadata de salsas elegibles para pack
const ELIGIBLE_BUNDLE_SAUCES = {
  'original-sr-pecado': {
    title: 'Original - Sr. Pecado',
    image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/ORIGINAL.png?v=1763243884',
    spice: '🌶️🌶️🌶️ 3/7',
    price: 4990
  },
  'lujuria-sr-pecado': {
    title: 'Lujuria - Sr. Pecado',
    image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/LUJURIA.png?v=1763244623',
    spice: '🌶️ 1/7',
    price: 4990
  },
  'inocente-sr-pecado': {
    title: 'Inocente - Sr. Pecado',
    image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/INOCENTE.png?v=1763245083',
    spice: '🌶️🌶️ 2/7',
    price: 4990
  },
  'caprichoso-sr-pecado': {
    title: 'Caprichoso - Sr. Pecado',
    image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/CAPRICHOSO_b2f779ac-2601-41c4-ba6b-e40c368fa5e8.png?v=1763245572',
    spice: '🌶️🌶️ 2/7',
    price: 4990
  },
  'pebre-chileno-premium': {
    title: 'Pebre Chileno Premium',
    image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/pebre.jpg?v=1759947852',
    spice: '🌶️🌶️🌶️🌶️ 4/7',
    price: 3500
  }
};

// Precios reales por handle de las salsas elegibles para pack
const PACK_SAUCE_PRICES = {
  'original-sr-pecado': 4990,
  'lujuria-sr-pecado': 4990,
  'inocente-sr-pecado': 4990,
  'caprichoso-sr-pecado': 4990,
  'pebre-chileno-premium': 3500
};
const DEFAULT_SAUCE_PRICE = 4990;

function getSaucePrice(handle) {
  return PACK_SAUCE_PRICES[handle] || (ELIGIBLE_BUNDLE_SAUCES[handle] ? ELIGIBLE_BUNDLE_SAUCES[handle].price : DEFAULT_SAUCE_PRICE);
}

// Dynamic bundle pricing initialization from DOM attributes rendered by Shopify Liquid
function initBundlePricesFromDOM() {
  const rows = document.querySelectorAll('.bundle-sauce-row');
  if (!rows || rows.length === 0) return;

  rows.forEach(row => {
    const handle = row.getAttribute('data-handle') || row.getAttribute('data-product-handle');
    if (!handle) return;

    const priceAttr = row.getAttribute('data-price');
    const titleAttr = row.getAttribute('data-title');
    const imageAttr = row.getAttribute('data-image');
    const availableAttr = row.getAttribute('data-available');

    if (priceAttr) {
      const priceNum = Number(priceAttr);
      if (!isNaN(priceNum) && priceNum > 0) {
        PACK_SAUCE_PRICES[handle] = priceNum;
        if (ELIGIBLE_BUNDLE_SAUCES[handle]) {
          ELIGIBLE_BUNDLE_SAUCES[handle].price = priceNum;
        }
      }
    }
    if (titleAttr && ELIGIBLE_BUNDLE_SAUCES[handle]) {
      ELIGIBLE_BUNDLE_SAUCES[handle].title = titleAttr;
    }
    if (imageAttr && ELIGIBLE_BUNDLE_SAUCES[handle]) {
      ELIGIBLE_BUNDLE_SAUCES[handle].image = imageAttr;
    }
    if (availableAttr === 'false') {
      if (ELIGIBLE_BUNDLE_SAUCES[handle]) {
        ELIGIBLE_BUNDLE_SAUCES[handle].available = false;
      }
      row.classList.add('is-soldout');
      const incBtn = row.querySelector('.bundle-step-inc');
      if (incBtn) {
        incBtn.disabled = true;
        incBtn.classList.add('disabled');
      }
      const metaEl = row.querySelector('.bundle-sauce-row-meta');
      if (metaEl && !metaEl.querySelector('.badge-soldout-inline')) {
        const badge = document.createElement('span');
        badge.className = 'badge-soldout-inline';
        badge.style.cssText = 'color: var(--brand-red); font-weight: 700; margin-left: 6px;';
        badge.textContent = '(AGOTADO)';
        metaEl.appendChild(badge);
      }
    }
  });
}

function getDiscountPercentForCount(count) {
  if (count <= 1) return 0;
  if (count === 2) return 0.10;
  if (count === 3) return 0.12;
  if (count === 4) return 0.15;
  if (count === 5) return 0.17;
  if (count >= 6) return 0.20;
  return 0;
}

function getDiscountForSlot(slotIndex) {
  if (slotIndex === 0) return 0;
  if (slotIndex === 1) return 0.10;
  if (slotIndex === 2) return 0.12;
  if (slotIndex === 3) return 0.15;
  if (slotIndex === 4) return 0.17;
  return 0.20;
}

function calculateBundlePricing() {
  const count = bundleSelections.length;
  const totalFullPrice = bundleSelections.reduce(
    (sum, sauce) => sum + getSaucePrice(sauce.handle),
    0
  );
  const discountRate = getDiscountPercentForCount(count);
  const finalTotal = Math.round(totalFullPrice * (1 - discountRate));
  const totalSaved = totalFullPrice - finalTotal;
  const averageDiscountPercent = Math.round(discountRate * 100);

  return {
    finalTotal,
    totalSaved,
    averageDiscountPercent,
    totalFullPrice
  };
}

function addSauceToBundle(title, image, spice, handle, event) {
  if (event && event.stopPropagation) event.stopPropagation();

  const cleanHandle = handle || title.toLowerCase().replace(/[^a-z0-9]/g, '');
  const sauceMeta = ELIGIBLE_BUNDLE_SAUCES[cleanHandle];
  if (sauceMeta && sauceMeta.available === false) {
    showToast(`La salsa ${title} se encuentra agotada temporalmente.`);
    return;
  }

  if (bundleSelections.length >= MAX_BUNDLE_ITEMS) {
    showToast('¡Tu pack ya tiene 6 salsas! Elimina una si deseas cambiarla.');
    return;
  }

  bundleSelections.push({ title, image, spice, handle: cleanHandle });
  renderBundleSlots();
  
  const currentCount = bundleSelections.length;
  const discPct = Math.round(getDiscountPercentForCount(currentCount) * 100);
  if (discPct > 0) {
    showToast(`¡${title} añadida! (${discPct}% OFF acumulado en tu Pack) 🔥`);
  } else {
    showToast(`¡${title} añadida a tu pack!`);
  }
}

function changeSauceQuantityInBundle(handle, delta, event) {
  if (event && event.stopPropagation) event.stopPropagation();

  if (delta > 0) {
    const sauce = ELIGIBLE_BUNDLE_SAUCES[handle];
    if (sauce) {
      addSauceToBundle(sauce.title, sauce.image, sauce.spice, handle);
    }
  } else if (delta < 0) {
    for (let i = bundleSelections.length - 1; i >= 0; i--) {
      if (bundleSelections[i].handle === handle) {
        removeSauceFromBundle(i);
        break;
      }
    }
  }
}

function removeSauceFromBundle(index, event) {
  if (event && event.stopPropagation) event.stopPropagation();
  bundleSelections.splice(index, 1);
  renderBundleSlots();
  showToast('Salsa removida del pack');
}

function renderBundleSlots() {
  const container = document.getElementById('bundle-slots-container');
  const countEl = document.getElementById('bundle-count');
  if (!container) return;

  if (countEl) {
    countEl.textContent = bundleSelections.length;
  }

  // Count by handle
  const handleCounts = {};
  for (const sauce of bundleSelections) {
    handleCounts[sauce.handle] = (handleCounts[sauce.handle] || 0) + 1;
  }

  // Update stepper quantities in sauce rows
  Object.keys(ELIGIBLE_BUNDLE_SAUCES).forEach(handle => {
    const qtyEl = document.getElementById(`bundle-qty-${handle}`);
    const rowEl = document.querySelector(`.bundle-sauce-row[data-handle="${handle}"]`);
    const count = handleCounts[handle] || 0;
    if (qtyEl) {
      qtyEl.textContent = count;
    }
    if (rowEl) {
      if (count > 0) {
        rowEl.classList.add('has-qty');
      } else {
        rowEl.classList.remove('has-qty');
      }
      const decBtn = rowEl.querySelector('.bundle-step-dec');
      if (decBtn) {
        decBtn.disabled = count === 0;
        if (count === 0) decBtn.classList.add('disabled');
        else decBtn.classList.remove('disabled');
      }
      const incBtn = rowEl.querySelector('.bundle-step-inc');
      if (incBtn) {
        const isSoldout = ELIGIBLE_BUNDLE_SAUCES[handle] && ELIGIBLE_BUNDLE_SAUCES[handle].available === false;
        incBtn.disabled = isSoldout || bundleSelections.length >= MAX_BUNDLE_ITEMS;
        if (incBtn.disabled) incBtn.classList.add('disabled');
        else incBtn.classList.remove('disabled');
      }
    }
  });

  // Render 6 Tray Slots
  let trayHtml = '';
  for (let i = 0; i < MAX_BUNDLE_ITEMS; i++) {
    const slotDiscPct = Math.round(getDiscountForSlot(i) * 100);
    const discLabel = slotDiscPct > 0 ? `-${slotDiscPct}%` : 'Base';

    if (i < bundleSelections.length) {
      const sauce = bundleSelections[i];
      trayHtml += `
        <div class="bundle-tray-slot filled" onclick="removeSauceFromBundle(${i}, event)" title="Toca para remover ${sauce.title}">
          <button class="bundle-tray-remove" onclick="removeSauceFromBundle(${i}, event)" title="Remover salsa">✕</button>
          <img class="bundle-tray-img" src="${sauce.image}" alt="${sauce.title}">
          ${slotDiscPct > 0 ? `<span class="bundle-tray-disc-pill">-${slotDiscPct}%</span>` : ''}
        </div>
      `;
    } else {
      trayHtml += `
        <div class="bundle-tray-slot" onclick="showToast('Selecciona una salsa con el botón + para agregar')" title="Slot ${i + 1} (${discLabel})">
          <span class="bundle-tray-slot-num">${i + 1}</span>
          <span class="bundle-tray-slot-disc">${discLabel}</span>
        </div>
      `;
    }
  }
  container.innerHTML = trayHtml;

  // Update Price & Badge
  const { finalTotal, totalFullPrice, averageDiscountPercent } = calculateBundlePricing();
  const priceEl = document.getElementById('bundle-total-price');
  const oldPriceEl = document.getElementById('bundle-old-price');
  const discountBadgeEl = document.getElementById('bundle-discount-badge');

  if (priceEl) {
    priceEl.textContent = formatCLP(finalTotal).replace(' CLP', '');
  }

  if (oldPriceEl) {
    if (bundleSelections.length >= 2 && totalFullPrice > finalTotal) {
      oldPriceEl.style.display = 'inline';
      oldPriceEl.textContent = formatCLP(totalFullPrice).replace(' CLP', '');
    } else {
      oldPriceEl.style.display = 'none';
    }
  }

  if (discountBadgeEl) {
    if (bundleSelections.length >= 2) {
      discountBadgeEl.style.display = 'inline-block';
      discountBadgeEl.textContent = `-${averageDiscountPercent}% OFF EN TU PACK`;
    } else {
      discountBadgeEl.style.display = 'none';
    }
  }
}

async function addCustomBundleToCart() {
  if (bundleSelections.length === 0) {
    showToast('Por favor selecciona al menos 1 salsa para armar tu pack.');
    return;
  }

  const { finalTotal, averageDiscountPercent } = calculateBundlePricing();
  const bundleId = 'pack_' + Date.now() + '_' + Math.random().toString(36).substr(2, 4);
  const bundleName = `Pack Chester x${bundleSelections.length}`;
  
  showToast(`¡${bundleName} agregado al carrito! (${averageDiscountPercent}% OFF) 🔥`);
  openCart();
  
  if (isShopifyLive()) {
    try {
      const itemsPayload = [];
      for (const sauce of bundleSelections) {
        const variantId = await resolveShopifyVariantId(null, sauce.handle || sauce.title);
        if (variantId) {
          itemsPayload.push({
            id: Number(variantId),
            quantity: 1,
            properties: {
              '_pack_chester': 'true',
              '_bundle_id': bundleId,
              'Pack': `${bundleName} (-${averageDiscountPercent}% OFF)`
            }
          });
        }
      }
      if (itemsPayload.length > 0) {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: itemsPayload })
        });

        await syncFromShopifyBackend();
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      }
    } catch (e) {
      console.warn('[Shopify Bundle Sync Error]', e);
    }
  } else {
    // Consolidar salsas idénticas dentro del pack
    const groupedSauces = {};
    for (const sauce of bundleSelections) {
      if (!groupedSauces[sauce.handle]) {
        groupedSauces[sauce.handle] = {
          sauce: sauce,
          qty: 0
        };
      }
      groupedSauces[sauce.handle].qty += 1;
    }

    for (const [handle, data] of Object.entries(groupedSauces)) {
      const sauce = data.sauce;
      const price = getSaucePrice(sauce.handle);
      cart.push({
        id: sauce.handle + '_' + bundleId,
        title: sauce.title,
        price: price,
        originalPrice: price,
        image: sauce.image,
        handle: sauce.handle,
        qty: data.qty,
        properties: { 
          '_pack_chester': 'true', 
          '_bundle_id': bundleId,
          'Pack': `${bundleName} (-${averageDiscountPercent}% OFF)` 
        }
      });
    }
    saveCart();
    renderCart();
  }

  bundleSelections = [];
  renderBundleSlots();
}

// ----------------------------------------------------
// HOT SAUCE MATCH QUIZ
// ----------------------------------------------------
let quizAnswers = {
  heat: '',
  occasion: ''
};

function selectQuizAnswer(step, answer) {
  if (step === 1) {
    quizAnswers.heat = answer;
    const s1 = document.getElementById('quiz-step-1');
    const s2 = document.getElementById('quiz-step-2');
    if (s1) s1.classList.remove('active');
    if (s2) s2.classList.add('active');
  } else if (step === 2) {
    quizAnswers.occasion = answer;
    const s2 = document.getElementById('quiz-step-2');
    const sr = document.getElementById('quiz-step-result');
    if (s2) s2.classList.remove('active');
    calculateQuizMatch();
    if (sr) sr.classList.add('active');
  }
}

let currentQuizMatchedSauce = null;

function calculateQuizMatch() {
  const resultContainer = document.getElementById('quiz-result-content');
  if (!resultContainer) return;

  let matchedSauce = {
    id: 4,
    handle: 'original-sr-pecado',
    title: 'Sr. Pecado Original (🌶️ 3/7)',
    originalPrice: 4990,
    desc: 'El balance maestro entre picor ahumado y sabor versátil para hamburguesas, sándwiches y comidas de todos los días.',
    image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/ORIGINAL.png?v=1763243884'
  };

  if (quizAnswers.heat === 'suave') {
    if (quizAnswers.occasion === 'picoteo') {
      matchedSauce = {
        id: 5,
        handle: 'lujuria-sr-pecado',
        title: 'Sr. Pecado - Lujuria (🌶️ 1/7)',
        originalPrice: 4990,
        desc: '¡Tu match supremo! Cremosa combinación con avellanas y cajú para quesos, tablas y picoteos gourmet.',
        image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/LUJURIA.png?v=1763244623'
      };
    } else if (quizAnswers.occasion === 'asado') {
      matchedSauce = {
        id: 7,
        handle: 'caprichoso-sr-pecado',
        title: 'Sr. Pecado - Caprichoso (🌶️ 2/7)',
        originalPrice: 4990,
        desc: '¡Salsa Macha picante de cebolla caramelizada y almendras doradas! Textura crujiente ideal para carnes, empanadas y picoteos.',
        image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/CAPRICHOSO_b2f779ac-2601-41c4-ba6b-e40c368fa5e8.png?v=1763245572'
      };
    } else {
      matchedSauce = {
        id: 6,
        handle: 'inocente-sr-pecado',
        title: 'Sr. Pecado - Inocente (🌶️ 2/7)',
        originalPrice: 4990,
        desc: 'Maní tostado y especias en un picor súper amigable que realza hamburguesas y sándwiches sin hacerte llorar.',
        image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/INOCENTE.png?v=1763245083'
      };
    }
  } else if (quizAnswers.heat === 'medio') {
    if (quizAnswers.occasion === 'picoteo') {
      matchedSauce = {
        id: 9,
        handle: 'honey-bonnet-salsa-picante-aji-scotch-bonnet-y-miel',
        title: 'Honey Bonnet (🌶️ 5/7)',
        originalPrice: 19990,
        desc: '¡Exquisito contraste dulce y picante! Ají Scotch Bonnet con miel pura de abeja, perfecto para quesos maduros y tablas.',
        image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/Honey.jpg?v=1759343270'
      };
    } else if (quizAnswers.occasion === 'asado') {
      matchedSauce = {
        id: 8,
        handle: 'pebre-chileno-premium',
        title: 'Pebre Chileno Premium (🌶️ 4/7)',
        originalPrice: 3500,
        desc: '¡El rey indiscutido del asado! Ají cacho de cabra con cilantro y sazón tradicional chilena para carnes y choripán.',
        image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/pebre.jpg?v=1759947852'
      };
    } else {
      matchedSauce = {
        id: 4,
        handle: 'original-sr-pecado',
        title: 'Sr. Pecado Original (🌶️ 3/7)',
        originalPrice: 4990,
        desc: 'El balance maestro entre picor ahumado y sabor versátil para hamburguesas, sándwiches y comidas de todos los días.',
        image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/ORIGINAL.png?v=1763243884'
      };
    }
  } else if (quizAnswers.heat === 'fuego') {
    if (quizAnswers.occasion === 'sandwich') {
      matchedSauce = {
        id: 11,
        handle: 'gator-salsa-picante-aji-pepper-x',
        title: 'Gator - Pepper X (🌶️ 8/7)',
        originalPrice: 26990,
        desc: '¡La bestia de las bestias! Con Pepper X (el ají más picante del mundo) para convertir tu hamburguesa en un reto épico.',
        image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/Gator.jpg?v=1758167036'
      };
    } else {
      matchedSauce = {
        id: 10,
        handle: 'voodoo-prince-death-mamba-salsa-picante-aji-ghost-pepper',
        title: 'Voodoo Prince Death Mamba (🌶️ 7/7)',
        originalPrice: 21990,
        desc: '¡Solo para Chester valientes! Picor puro de Ghost Pepper para asados extremos y los que no le temen al verdadero fuego.',
        image: 'https://cdn.shopify.com/s/files/1/0761/4034/7646/files/vodoo.jpg?v=1758166366'
      };
    }
  }

  // Dinamización en dos capas: resolver precio actual de catálogo (DOM o backend Shopify)
  const currentCatalogPrice = getProductCatalogPrice(matchedSauce.handle, matchedSauce.originalPrice);
  if (currentCatalogPrice > 0) {
    matchedSauce.originalPrice = currentCatalogPrice;
  }
  currentQuizMatchedSauce = matchedSauce;

  const discountedPrice = Math.round(matchedSauce.originalPrice * 0.9);

  resultContainer.innerHTML = `
    <div class="quiz-result-img-wrap">
      <img src="${matchedSauce.image}" alt="${matchedSauce.title}" class="quiz-result-img">
    </div>
    <div class="quiz-result-info">
      <div class="quiz-result-badge-wrap">
        <span class="quiz-result-badge">-10% OFF MATCH</span>
      </div>
      <h3 class="quiz-result-title">${matchedSauce.title}</h3>
      <p class="quiz-result-desc">${matchedSauce.desc}</p>
      <div class="quiz-result-price-wrap">
        <span class="quiz-result-price-current">${formatCLP(discountedPrice)}</span>
        <span class="quiz-result-price-old">${formatCLP(matchedSauce.originalPrice)}</span>
      </div>
      <div class="quiz-result-actions">
        <button class="btn btn-fire quiz-result-btn" onclick="addQuizMatchToCart(${matchedSauce.id}, '${matchedSauce.title}', ${matchedSauce.originalPrice}, ${discountedPrice}, '${matchedSauce.image}', '${matchedSauce.handle}')">
          ¡AGREGAR AL CARRITO! 🔥
        </button>
      </div>
    </div>
  `;
}

function resetQuiz() {
  quizAnswers = { heat: '', occasion: '' };
  currentQuizMatchedSauce = null;
  const sr = document.getElementById('quiz-step-result');
  const s2 = document.getElementById('quiz-step-2');
  const s1 = document.getElementById('quiz-step-1');
  if (sr) sr.classList.remove('active');
  if (s2) s2.classList.remove('active');
  if (s1) s1.classList.add('active');
}

// Newsletter Handler
function handleNewsletter(e) {
  e.preventDefault();
  showToast('¡Bienvenido a la comunidad Chester! 🌶️ Te enviamos un 10% OFF');
  e.target.reset();
}

// Shopify Live Cart Auto-Sync
async function syncFromShopifyBackend() {
  if (!isShopifyLive()) {
    updateBadge();
    return;
  }
  try {
    const res = await fetch('/cart.js');
    if (res.ok) {
      const shopifyCart = await res.json();
      if (shopifyCart && Array.isArray(shopifyCart.items)) {
        if (shopifyCart.items.length === 0) {
          cart = cart.filter(item => Number(item.qty) > 0);
        } else {
          cart = shopifyCart.items.map(item => {
            const rawOriginalPrice = (item.original_price || item.price || 0) / 100;
            const isMatch = item.properties && (item.properties['_quiz_match'] === 'true' || item.properties['Match']);
            const finalDiscountedPrice = isMatch ? Math.round(rawOriginalPrice * 0.9) : ((item.final_price || item.price || 0) / 100);

            return {
              id: item.key || item.id,
              key: item.key || String(item.id),
              variantId: item.variant_id || item.id,
              title: item.title,
              price: finalDiscountedPrice,
              image: item.image || (item.featured_image ? item.featured_image.url : '') || '',
              handle: item.handle || (item.url ? item.url.split('?')[0].split('/').pop() : ''),
              qty: item.quantity,
              properties: item.properties || {},
              discounts: item.line_level_discount_allocations || [],
              originalPrice: rawOriginalPrice,
              finalPrice: finalDiscountedPrice
            };
          });
        }
        localStorage.setItem('picaradoble_cart', JSON.stringify(cart));
        renderCart();
      }
    }
  } catch (err) {
    console.warn('[Shopify Cart Sync]', err);
  } finally {
    updateBadge();
  }
}

// Dynamic Header Offset Measurement for Smooth Scroll Alignment
function initHeaderOffsetSync() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  function updateOffset() {
    const h = header.offsetHeight;
    if (h > 0) {
      document.documentElement.style.setProperty('--header-height', `${h}px`);
    }
  }

  updateOffset();
  window.addEventListener('resize', updateOffset, { passive: true });
  window.addEventListener('orientationchange', updateOffset, { passive: true });

  if (window.ResizeObserver) {
    const ro = new ResizeObserver(() => updateOffset());
    ro.observe(header);
  }
}
window.initHeaderOffsetSync = initHeaderOffsetSync;

// Global Event Listeners & Initialization
function initApp() {
  const cartTriggerBtn = document.getElementById('cart-trigger-btn');
  const cartCloseBtn = document.getElementById('cart-close-btn');
  const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
  
  initHeaderOffsetSync();
  
  // Mobile Nav Dropdown & Drawer Listeners
  document.querySelectorAll('#mobile-menu-trigger-btn, .mobile-menu-btn').forEach(btn => {
    if (!btn.getAttribute('onclick')) {
      btn.addEventListener('click', toggleMobileNav);
    }
  });
  document.querySelectorAll('#mobile-nav-close-btn, .mobile-nav-close').forEach(btn => {
    if (!btn.getAttribute('onclick')) {
      btn.addEventListener('click', closeMobileNav);
    }
  });
  document.querySelectorAll('.mobile-nav-backdrop, #mobile-nav-backdrop').forEach(backdrop => {
    if (!backdrop.getAttribute('onclick')) {
      backdrop.addEventListener('click', closeMobileNav);
    }
  });
  document.querySelectorAll('.mobile-nav-dropdown a, .mobile-nav-links a').forEach(link => {
    link.addEventListener('click', handleMobileNavLinkClick);
  });
  document.querySelectorAll('.mobile-nav-drawer-overlay, #mobile-nav-overlay').forEach(overlay => {
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeMobileNav(e);
    });
  });

  // Cart Listeners
  if (cartTriggerBtn) cartTriggerBtn.addEventListener('click', openCart);
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', (e) => {
      if (e.target === cartDrawerOverlay) closeCart();
    });
  }

  // Global delegation fallback for dynamic themes
  document.addEventListener('click', (e) => {
    const mobileBtn = e.target.closest('#mobile-menu-trigger-btn, .mobile-menu-btn');
    if (mobileBtn && !mobileBtn.getAttribute('onclick')) {
      toggleMobileNav(e);
    }
    const backdrop = e.target.closest('#mobile-nav-backdrop, .mobile-nav-backdrop');
    if (backdrop && !backdrop.getAttribute('onclick')) {
      closeMobileNav(e);
    }
  });

  // Close modals on Escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMobileNav();
      closeCart();
      closeCatadorModal();
      closeStockNotifyModal();
    }
  });

  // Modal backdrop click for stock notification modal
  const stockModalEl = document.getElementById('stock-notify-modal');
  if (stockModalEl) {
    stockModalEl.addEventListener('click', (e) => {
      if (e.target === stockModalEl) {
        closeStockNotifyModal();
      }
    });
  }

  // Real-time Event Listeners for Cart Updates
  document.addEventListener('cart:refresh', syncFromShopifyBackend);
  document.addEventListener('cart:updated', syncFromShopifyBackend);
  window.addEventListener('storage', (e) => {
    if (e.key === 'picaradoble_cart') {
      try {
        cart = JSON.parse(e.newValue || '[]');
        renderCart();
        updateBadge();
      } catch (err) {}
    }
  });

  initSpiceFilters();
  initCatalogPricesFromDOM();
  initBundlePricesFromDOM();
  renderCart();
  renderBundleSlots();
  updateBadge();
  syncFromShopifyBackend();
  try {
    initCatadorExperience();
  } catch (err) {
    console.warn('[Catador VIP Init Error]', err);
  }
  initStockNotifyHover();
  initJudgeMeSingleStepModal();
  refreshLivePricesFromShopify();
}

// Dynamically refresh displayed prices & inventory availability from live Shopify product endpoints
async function refreshLivePricesFromShopify() {
  if (!isShopifyLive()) return;
  const elements = document.querySelectorAll('[data-product-handle], .bundle-sauce-row[data-handle]');
  const handlesSeen = new Set();
  let bundlePricingUpdated = false;
  
  for (const el of elements) {
    const handle = el.getAttribute('data-product-handle') || el.getAttribute('data-handle');
    if (!handle || handlesSeen.has(handle)) continue;
    handlesSeen.add(handle);

    try {
      const res = await fetch(`/products/${encodeURIComponent(handle)}.js`);
      if (res.ok) {
        const prod = await res.json();
        if (prod) {
          const isAvailable = Boolean(prod.available);
          const realPriceCLP = typeof prod.price === 'number' ? Math.round(prod.price / 100) : 0;
          const formatted = realPriceCLP > 0 ? formatCLP(realPriceCLP) : '';

          if (realPriceCLP > 0) {
            CATALOG_PRODUCT_PRICES[handle] = realPriceCLP;
          }

          // 1. Update Price in Catalog, Hero & Posters
          const priceTag = el.querySelector('.poster-price-tag, .product-price, .hero-poster-price');
          if (priceTag && formatted) {
            if (priceTag.classList.contains('poster-price-tag') || priceTag.classList.contains('product-price') || el.classList.contains('poster-card') || el.classList.contains('product-card')) {
              priceTag.textContent = formatted.replace(' CLP', '');
            } else {
              priceTag.textContent = formatted;
            }
          }

          // 2. Update Price in Bundle Builder if eligible sauce
          if (ELIGIBLE_BUNDLE_SAUCES[handle] || PACK_SAUCE_PRICES[handle]) {
            if (realPriceCLP > 0 && PACK_SAUCE_PRICES[handle] !== realPriceCLP) {
              PACK_SAUCE_PRICES[handle] = realPriceCLP;
              if (ELIGIBLE_BUNDLE_SAUCES[handle]) {
                ELIGIBLE_BUNDLE_SAUCES[handle].price = realPriceCLP;
              }
              bundlePricingUpdated = true;
            }

            const bundleRow = document.querySelector(`.bundle-sauce-row[data-handle="${handle}"]`);
            if (bundleRow) {
              bundleRow.setAttribute('data-price', realPriceCLP);
              const priceDisplay = bundleRow.querySelector('.bundle-sauce-price-display');
              if (priceDisplay && realPriceCLP > 0) {
                priceDisplay.textContent = formatCLP(realPriceCLP).replace(' CLP', '');
              }
            }
          }

          // 3. Inventory / Availability Handling
          // CASE A: Packs in Poster Grid - ALWAYS show! If out of stock, activate "Avísenme cuando esté disponible"
          if (el.classList.contains('poster-card')) {
            el.style.display = ''; // ALWAYS KEEP VISIBLE!
            const buyBtn = el.querySelector('.poster-price-row button');
            const packTitle = el.querySelector('.poster-super-title')?.textContent.trim() || handle;
            const packImg = el.querySelector('.poster-card-image-wrap img')?.src || '';
            const subtitleBadge = el.querySelector('.poster-subtitle-badge');

            if (!isAvailable) {
              el.classList.add('is-soldout');
              if (subtitleBadge && !subtitleBadge.dataset.origText) {
                subtitleBadge.dataset.origText = subtitleBadge.textContent;
              }
              if (subtitleBadge) {
                subtitleBadge.textContent = '⚠️ TEMPORALMENTE AGOTADO';
                subtitleBadge.classList.add('badge-soldout-pack');
              }
              if (buyBtn) {
                if (!buyBtn.dataset.origHtml) buyBtn.dataset.origHtml = buyBtn.innerHTML;
                buyBtn.className = 'btn btn-notify-stock';
                buyBtn.innerHTML = '🔔 Avísenme cuando<br>esté disponible';
                buyBtn.onclick = (e) => {
                  e.preventDefault();
                  openStockNotifyModal(handle, packTitle, packImg);
                };
              }
            } else {
              el.classList.remove('is-soldout');
              if (subtitleBadge && subtitleBadge.dataset.origText) {
                subtitleBadge.textContent = subtitleBadge.dataset.origText;
                subtitleBadge.classList.remove('badge-soldout-pack');
              }
              if (buyBtn && buyBtn.dataset.origHtml) {
                buyBtn.className = el.classList.contains('poster-red') ? 'btn btn-primary' : 'btn btn-fire';
                buyBtn.innerHTML = buyBtn.dataset.origHtml;
              }
            }
          }

          // CASE A2: Hero Visual Card - NEVER hide the hero section (preserves visual layout)
          if (el.classList.contains('hero-visual-card')) {
            el.style.display = ''; // Always keep hero visible
            const heroBadge = el.querySelector('.product-badge-float');
            const heroBtn = el.querySelector('.hero-poster-price-bar button, button');
            const heroTitle = el.querySelector('.hero-poster-headline')?.textContent.trim() || handle;
            const heroImg = el.querySelector('.hero-product-img-featured')?.src || '';

            if (!isAvailable) {
              if (heroBadge) {
                heroBadge.className = 'product-badge-float badge-soldout';
                heroBadge.textContent = 'AGOTADO';
              }
              if (heroBtn) {
                heroBtn.className = 'btn btn-notify-stock btn-sm';
                heroBtn.innerHTML = '🔔 Avísenme cuando esté disponible';
                heroBtn.onclick = (e) => {
                  e.preventDefault();
                  openStockNotifyModal(handle, heroTitle, heroImg);
                };
              }
            } else {
              if (heroBadge) {
                heroBadge.className = 'product-badge-float badge-fire';
                heroBadge.textContent = 'RECOMENDADO';
              }
              if (heroBtn) {
                heroBtn.className = 'btn btn-fire btn-sm';
                heroBtn.textContent = '¡COMPRAR PACK!';
              }
            }
          }

          // CASE B: Individual Product Cards in Catalog
          const catalogCards = document.querySelectorAll(`.product-card[data-product-handle="${handle}"]`);
          catalogCards.forEach(card => {
            if (formatted) {
              const cardPrice = card.querySelector('.product-price');
              if (cardPrice) cardPrice.textContent = formatted.replace(' CLP', '');
            }
            const titleLink = card.querySelector('.product-title a');
            if (titleLink && prod.title) {
              titleLink.textContent = prod.title;
            }
            card.setAttribute('data-available', String(isAvailable));
            applyCatalogCardSoldOut(card, !isAvailable);
          });

          // Check cart upsell section if it features this sauce
          const upsellSection = document.getElementById('cart-upsell-section');
          if (upsellSection && !isAvailable) {
            const upsellBtn = upsellSection.querySelector('.btn-upsell-add');
            if (upsellBtn && upsellBtn.getAttribute('onclick')?.includes(handle)) {
              upsellSection.style.display = 'none';
            }
          }

          // CASE C: Bundle Builder Sauces
          if (ELIGIBLE_BUNDLE_SAUCES[handle]) {
            ELIGIBLE_BUNDLE_SAUCES[handle].available = isAvailable;
            if (prod.title) {
              ELIGIBLE_BUNDLE_SAUCES[handle].title = prod.title;
            }
            const bundleRow = document.querySelector(`.bundle-sauce-row[data-handle="${handle}"]`);
            if (bundleRow) {
              bundleRow.setAttribute('data-available', String(isAvailable));
              if (prod.title) {
                bundleRow.setAttribute('data-title', prod.title);
                const rowTitle = bundleRow.querySelector('.bundle-sauce-row-title');
                if (rowTitle) {
                  rowTitle.textContent = prod.title;
                }
              }
              const incBtn = bundleRow.querySelector('.bundle-step-inc');
              const metaEl = bundleRow.querySelector('.bundle-sauce-row-meta');
              if (!isAvailable) {
                bundleRow.classList.add('is-soldout');
                if (incBtn) {
                  incBtn.disabled = true;
                  incBtn.classList.add('disabled');
                }
                if (metaEl && !metaEl.querySelector('.badge-soldout-inline')) {
                  const badge = document.createElement('span');
                  badge.className = 'badge-soldout-inline';
                  badge.style.cssText = 'color: var(--brand-red); font-weight: 700; margin-left: 6px;';
                  badge.textContent = '(AGOTADO)';
                  metaEl.appendChild(badge);
                }
              } else {
                bundleRow.classList.remove('is-soldout');
                if (incBtn && bundleSelections.length < MAX_BUNDLE_ITEMS) {
                  incBtn.disabled = false;
                  incBtn.classList.remove('disabled');
                }
                const badge = metaEl ? metaEl.querySelector('.badge-soldout-inline') : null;
                if (badge) badge.remove();
              }
            }
          }

          // CASE D: Real-time update for Test Chester match if active
          if (currentQuizMatchedSauce && currentQuizMatchedSauce.handle === handle && realPriceCLP > 0) {
            currentQuizMatchedSauce.originalPrice = realPriceCLP;
            const discounted = Math.round(realPriceCLP * 0.9);
            const currEl = document.querySelector('#quiz-result-content .quiz-result-price-current');
            const oldEl = document.querySelector('#quiz-result-content .quiz-result-price-old');
            const btn = document.querySelector('#quiz-result-content .quiz-result-btn');
            if (currEl) currEl.textContent = formatCLP(discounted);
            if (oldEl) oldEl.textContent = formatCLP(realPriceCLP);
            if (btn) {
              btn.setAttribute('onclick', `addQuizMatchToCart(${currentQuizMatchedSauce.id}, '${currentQuizMatchedSauce.title}', ${realPriceCLP}, ${discounted}, '${currentQuizMatchedSauce.image}', '${currentQuizMatchedSauce.handle}')`);
            }
          }
        }
      }
    } catch (e) {
      console.warn('[Shopify Live Sync Error]', handle, e);
    }
  }

  if (bundlePricingUpdated) {
    renderBundleSlots();
  }
}

// ----------------------------------------------------
// EXPERIENCIA CATADOR VIP & FEEDBACK (HACKING GROWTH)
// ----------------------------------------------------
window.__catadorData = null;
const CATADOR_WEBHOOK_URL = 'https://script.google.com/macros/s/AKfycbweseEoJbZRO7k_XUWK3Y3bZMnG0nSkV4jNazgvdN0uUwoxY5VrKgQbgOo8eFVWJ6hV/exec';

const CATADOR_USO_MAP = {
  'asados': '🥩 En Asados / A la Parrilla',
  'picoteo': '🧀 En Picoteo / Tablas con Queso y Nachos',
  'hamburguesas': '🍔 En Hamburguesas / Sanguchitos Caseros',
  'mexicana': '🌮 En Tacos / Comida Mexicana',
  'diario': '🍽️ En Almuerzos / Comida de Diario'
};

const CATADOR_PRODUCTOS_MAP = {
  'original': 'Original - Sr. Pecado',
  'lujuria': 'Lujuria - Sr. Pecado',
  'inocente': 'Inocente - Sr. Pecado',
  'caprichoso': 'Caprichoso - Sr. Pecado',
  'pebre': 'Pebre Chileno DeCamacho',
  'pack-sabor': 'Pack Sr. Pecado + Pebre',
  'pack-del-sabor': 'Pack Sr. Pecado + Pebre',
  'pack-pecados': 'Pack Todos los Pecados',
  'todos-los-pecados': 'Pack Todos los Pecados',
  'otro': 'Otro'
};

function selectCatadorProducto(prodName) {
  const hiddenInput = document.getElementById('catador-input-producto-hidden');
  if (hiddenInput) {
    hiddenInput.value = prodName;
  }

  // Actualizar estado activo en los botones de producto
  const prodButtons = document.querySelectorAll('.catador-product-btn');
  prodButtons.forEach(btn => {
    if (btn.getAttribute('data-producto') === prodName) {
      btn.classList.add('selected');
    } else {
      btn.classList.remove('selected');
    }
  });

  const otroWrap = document.getElementById('catador-otro-producto-wrap');
  const otroInput = document.getElementById('catador-input-producto-otro');
  if (otroWrap) {
    if (prodName === 'Otro') {
      otroWrap.style.display = 'block';
      if (otroInput) {
        otroInput.required = true;
        otroInput.focus();
      }
    } else {
      otroWrap.style.display = 'none';
      if (otroInput) {
        otroInput.required = false;
        otroInput.value = '';
      }
    }
  }

  if (window.__catadorData) {
    window.__catadorData.productoComprado = prodName;
  }
}

function selectCatadorUso(usoKey) {
  const normalizedKey = (usoKey || 'asados').toLowerCase();
  const hiddenInput = document.getElementById('catador-input-uso-hidden');
  if (hiddenInput) {
    hiddenInput.value = normalizedKey;
  }

  // Actualizar estado activo en los botones de pill
  const pillButtons = document.querySelectorAll('.catador-pill-btn');
  pillButtons.forEach(btn => {
    if (btn.getAttribute('data-uso') === normalizedKey) {
      btn.classList.add('selected');
    } else {
      btn.classList.remove('selected');
    }
  });

  if (window.__catadorData) {
    window.__catadorData.rawUso = normalizedKey;
    window.__catadorData.usoTexto = CATADOR_USO_MAP[normalizedKey] || normalizedKey;
  }
}

function initCatadorExperience() {
  const params = new URLSearchParams(window.location.search);
  const isCatador = params.get('catador') === 'true' || params.get('catador') === '1' || params.has('catador');
  if (!isCatador) return;

  const rawNombre = params.get('nombre') || params.get('first_name') || params.get('name') || '';
  const rawEmail = params.get('email') || '';
  const rawUso = params.get('uso') || 'asados';
  const rawOrigen = params.get('origen') || params.get('canal') || params.get('source') || 'web';
  const origen = ['whatsapp', 'email', 'ig', 'direct', 'sms'].includes(rawOrigen.toLowerCase()) ? rawOrigen.toLowerCase() : 'web';

  // Sanitizar si viene la etiqueta Liquid sin procesar (ej: {{ customer.first_name }} o %7B%7B)
  const isInvalidPlaceholder = (val) => !val || val.includes('{{') || val.includes('{') || val.includes('%7B');
  const nombre = isInvalidPlaceholder(rawNombre) ? '' : rawNombre.trim();
  const email = isInvalidPlaceholder(rawEmail) ? '' : rawEmail.trim();

  const usoTexto = (CATADOR_USO_MAP && CATADOR_USO_MAP[rawUso.toLowerCase()]) || (rawUso ? `🔥 ${rawUso}` : '🥩 En Asados / A la Parrilla');

  window.__catadorData = {
    nombre: nombre,
    rawUso: rawUso.toLowerCase(),
    usoTexto: usoTexto,
    email: email,
    origen: origen
  };

  // Mostrar campo de email de respaldo si no viene en los parámetros URL
  const contactGroup = document.getElementById('catador-contact-group');
  const emailInput = document.getElementById('catador-input-email');
  if (contactGroup) {
    if (!email) {
      contactGroup.style.display = 'block';
      if (emailInput) emailInput.required = true;
    } else {
      contactGroup.style.display = 'none';
      if (emailInput) emailInput.required = false;
    }
  }

  // Guardar cupón en localStorage para que checkoutRedirect lo inyecte
  try {
    localStorage.setItem('picara_applied_discount', 'CATADORVIP');
  } catch (e) {}

  // Auto-aplicar cupón en backend silenciosamente si estamos en Shopify
  if (isShopifyLive()) {
    fetch('/discount/CATADORVIP', { method: 'GET' }).catch(() => {});
  }

  // Personalizar saludo con el nombre del cliente si está presente
  const titleEl = document.getElementById('catador-modal-title');
  const greetingEl = document.getElementById('catador-modal-greeting');
  if (nombre) {
    if (greetingEl) {
      greetingEl.textContent = `¡Hola ${nombre}! Queremos tu veredicto sincero:`;
      greetingEl.style.display = 'block';
    } else if (titleEl) {
      titleEl.textContent = `¡HOLA ${nombre.toUpperCase()}! TU VEREDICTO 🔥`;
    }
  }

  // Pre-seleccionar la opción de uso correspondiente
  selectCatadorUso(rawUso);

  // Pre-seleccionar producto comprado si viene en los parámetros URL
  const rawProducto = (params.get('producto') || '').toLowerCase().trim();
  if (rawProducto && CATADOR_PRODUCTOS_MAP[rawProducto]) {
    selectCatadorProducto(CATADOR_PRODUCTOS_MAP[rawProducto]);
  }

  const modal = document.getElementById('catador-modal');
  if (modal) {
    modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
    setTimeout(() => {
      modal.classList.add('active');
    }, 20);

    // Cerrar al hacer clic en el backdrop
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        closeCatadorModal();
      }
    });
  }
}

function closeCatadorModal(scrollToCatalog = false) {
  const modal = document.getElementById('catador-modal');
  if (!modal) return;
  modal.classList.remove('active');
  document.body.style.overflow = '';
  setTimeout(() => {
    modal.style.display = 'none';
  }, 250);

  if (scrollToCatalog) {
    const target = document.getElementById('packs-destacados') || 
                   document.getElementById('arma-tu-pack') || 
                   document.getElementById('catalogo-salsas');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  }
}

async function handleCatadorFormSubmit(e) {
  if (e && e.preventDefault) e.preventDefault();
  
  const submitBtn = document.getElementById('catador-btn-submit');

  // 1. Pregunta 1: Producto comprado / recordado
  const hiddenProd = document.getElementById('catador-input-producto-hidden');
  let productoComprado = (hiddenProd ? hiddenProd.value : '') || window.__catadorData?.productoComprado || '';
  if (!productoComprado) {
    showToast('⚠️ Por favor selecciona el producto que compraste');
    const container = document.getElementById('catador-products-container');
    if (container) container.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }
  if (productoComprado === 'Otro') {
    const otroInput = document.getElementById('catador-input-producto-otro');
    const otroVal = otroInput ? otroInput.value.trim() : '';
    productoComprado = otroVal ? `Otro: ${otroVal}` : 'Otro';
  }

  // 2. Pregunta 2: Momento de uso
  const hiddenUso = document.getElementById('catador-input-uso-hidden');
  const usoKey = (hiddenUso ? hiddenUso.value : '') || window.__catadorData?.rawUso || 'asados';
  const momentoUso = (CATADOR_USO_MAP && CATADOR_USO_MAP[usoKey.toLowerCase()]) || usoKey;

  // 3. Pregunta 3: Comida particular recordada
  const comidaInput = document.getElementById('catador-input-comida');
  const comidaParticular = comidaInput ? comidaInput.value.trim() : '';

  // 4. Pregunta 4: Salsa o producto deseado
  const salsaInput = document.getElementById('catador-input-salsa');
  const salsaDeseada = salsaInput ? salsaInput.value.trim() : '';

  const form = document.getElementById('catador-suggestion-form');
  const successMsg = document.getElementById('catador-success-msg');

  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'REGISTRANDO VEREDICTO... 🔥';
  }

  const emailInputEl = document.getElementById('catador-input-email');
  const userEnteredEmail = emailInputEl ? emailInputEl.value.trim() : '';
  const finalEmail = window.__catadorData?.email || userEnteredEmail || 'No informado';

  const payload = {
    nombre: window.__catadorData?.nombre || 'No informado',
    email: finalEmail,
    productoComprado: productoComprado,
    momentoUso: momentoUso,
    comidaParticular: comidaParticular,
    salsaDeseada: salsaDeseada,
    origen: window.__catadorData?.origen || 'web',
    timestamp: new Date().toISOString(),
    userAgent: navigator.userAgent
  };

  // 1. Guardar en localStorage
  try {
    const history = JSON.parse(localStorage.getItem('picara_catador_feedback') || '[]');
    history.push(payload);
    localStorage.setItem('picara_catador_feedback', JSON.stringify(history));
    localStorage.setItem('picara_catador_submitted', 'true');
  } catch (err) {}

  // 2. Enviar a Webhook de Google Sheets si está configurado
  const webhookUrl = window.CATADOR_WEBHOOK_URL || CATADOR_WEBHOOK_URL || '';
  if (webhookUrl) {
    try {
      fetch(webhookUrl, {
        method: 'POST',
        mode: 'no-cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      }).catch(err => {
        console.warn('[Catador Webhook Warn]', err);
      });
    } catch (err) {
      console.warn('[Catador Webhook]', err);
    }
  }

  // 3. Feedback visual y transición a la tienda
  if (form) form.style.display = 'none';
  if (successMsg) successMsg.style.display = 'block';

  showToast('🎉 ¡Veredicto registrado y 15% OFF activado! Te llevamos al catálogo...');

  setTimeout(() => {
    closeCatadorModal(true);
  }, 1400);
}

// STOCK NOTIFICATION MODAL ("Avísenme cuando esté disponible")
function openStockNotifyModal(handle, title, image) {
  const modal = document.getElementById('stock-notify-modal');
  if (!modal) return;

  const handleInput = document.getElementById('stock-notify-handle');
  const titleInput = document.getElementById('stock-notify-title-input');
  const nameEl = document.getElementById('stock-notify-product-name');
  const imgEl = document.getElementById('stock-notify-product-img');
  const form = document.getElementById('stock-notify-form');
  const successMsg = document.getElementById('stock-notify-success-msg');
  const contactInput = document.getElementById('stock-notify-contact');
  const waLink = document.getElementById('stock-notify-wa-link');

  const resolvedTitle = title || handle || 'Pack Picará Doble';
  if (handleInput) handleInput.value = handle || '';
  if (titleInput) titleInput.value = resolvedTitle;
  if (nameEl) nameEl.textContent = resolvedTitle;

  // Resolve image if not passed
  let resolvedImg = image;
  if (!resolvedImg && handle) {
    const poster = document.querySelector(`.poster-card[data-product-handle="${handle}"] img, .hero-visual-card[data-product-handle="${handle}"] img, .product-card[data-product-handle="${handle}"] img`);
    if (poster) resolvedImg = poster.src;
  }
  if (imgEl) {
    if (resolvedImg) {
      imgEl.src = resolvedImg;
      imgEl.style.display = 'block';
    } else {
      imgEl.style.display = 'none';
    }
  }

  // Update WhatsApp direct text
  if (waLink) {
    const textMsg = encodeURIComponent(`¡Hola Los Chesteres! 🔥 Quiero saber cuándo tendrán stock disponible de: ${resolvedTitle}`);
    waLink.href = `https://wa.me/56976062883?text=${textMsg}`;
  }

  // Reset form display
  if (form) form.style.display = 'block';
  if (successMsg) successMsg.style.display = 'none';
  if (contactInput) contactInput.value = '';

  modal.style.display = 'flex';
  setTimeout(() => modal.classList.add('active'), 10);
  if (contactInput) setTimeout(() => contactInput.focus(), 80);
}

function closeStockNotifyModal() {
  const modal = document.getElementById('stock-notify-modal');
  if (!modal) return;
  modal.classList.remove('active');
  setTimeout(() => {
    modal.style.display = 'none';
  }, 200);
}

async function handleStockNotifySubmit(event) {
  event.preventDefault();
  const contactInput = document.getElementById('stock-notify-contact');
  const handleInput = document.getElementById('stock-notify-handle');
  const titleInput = document.getElementById('stock-notify-title-input');
  const form = document.getElementById('stock-notify-form');
  const successMsg = document.getElementById('stock-notify-success-msg');
  const submitBtn = document.getElementById('stock-notify-submit-btn');

  const contactVal = contactInput ? contactInput.value.trim() : '';
  const handleVal = handleInput ? handleInput.value : '';
  const titleVal = titleInput ? titleInput.value : '';

  if (!contactVal) return;

  if (submitBtn) {
    submitBtn.disabled = true;
    submitBtn.textContent = 'REGISTRANDO... ⏳';
  }

  // 1. Save locally in localStorage
  try {
    const saved = JSON.parse(localStorage.getItem('picaradoble_stock_notifies') || '[]');
    saved.push({ contact: contactVal, handle: handleVal, title: titleVal, date: new Date().toISOString() });
    localStorage.setItem('picaradoble_stock_notifies', JSON.stringify(saved));
  } catch (e) {
    console.warn('LocalStorage error:', e);
  }

  // 2. Asynchronously submit to Shopify /contact form to generate customer message & email alert
  try {
    const formData = new FormData();
    formData.append('form_type', 'contact');
    formData.append('utf8', '✓');
    formData.append('contact[email]', contactVal.includes('@') ? contactVal : 'aviso-stock@picaradoble.com');
    formData.append('contact[body]', `[AVISO DE STOCK SOLICITADO] El cliente solicita aviso cuando haya stock disponible para el producto: ${titleVal} (handle: ${handleVal}). Dato de contacto: ${contactVal}`);
    await fetch('/contact', { method: 'POST', body: formData });
  } catch (err) {
    // Non-blocking fail-safe
  }

  // 3. Asynchronously submit to Google Sheets Webhook (Hoja "Avísenme cuando esté disponible")
  const webhookUrl = window.STOCK_NOTIFY_WEBHOOK_URL || window.CATADOR_WEBHOOK_URL || CATADOR_WEBHOOK_URL || '';
  if (webhookUrl) {
    try {
      const sheetPayload = {
        tipo: 'stock_notify',
        action: 'stock_notify',
        producto: titleVal,
        handle: handleVal,
        contacto: contactVal,
        tipoContacto: contactVal.includes('@') ? 'Email' : 'WhatsApp / Teléfono',
        timestamp: new Date().toISOString(),
        userAgent: navigator.userAgent
      };
      fetch(webhookUrl, {
        method: 'POST',
        mode: 'no-cors',
        keepalive: true,
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(sheetPayload)
      }).catch(err => {
        console.warn('[Stock Notify Sheet Webhook Warn]', err);
      });
    } catch (err) {
      console.warn('[Stock Notify Sheet Webhook]', err);
    }
  }

  if (submitBtn) {
    submitBtn.disabled = false;
    submitBtn.textContent = '🔔 ¡AVISARME APENAS HAYA STOCK!';
  }

  if (form) form.style.display = 'none';
  if (successMsg) successMsg.style.display = 'block';

  showToast('¡Listo! Quedaste anotado para aviso de stock 🔥');

  setTimeout(() => {
    closeStockNotifyModal();
  }, 2600);
}

// ----------------------------------------------------
// JUDGE.ME SINGLE-STEP REVIEW MODAL CUSTOMIZATION
// ----------------------------------------------------
function initJudgeMeSingleStepModal() {
  function applySingleStepAdjustments(modal) {
    if (!modal) return;

    // Check if currently on the Thank You confirmation page
    const thankYouPage = modal.querySelector('.jdgm-write-review-modal__page--thank-you');
    const thankYouSec = modal.querySelector('.jdgm-write-review-modal__section--page--thank-you');
    const isThankYou = modal.classList.contains('jdgm-write-review-modal--thank-you') ||
                       (thankYouPage && thankYouPage.classList.contains('current-page')) ||
                       (thankYouSec && thankYouSec.classList.contains('current-section'));

    if (isThankYou) {
      if (!modal.classList.contains('jdgm-write-review-modal--thank-you')) {
        modal.classList.add('jdgm-write-review-modal--thank-you');
      }

      // Ensure thank you close button cleanly closes the modal
      const thankYouCloseBtn = modal.querySelector('.jdgm-write-review-modal__nav-btn-close');
      if (thankYouCloseBtn && !thankYouCloseBtn.dataset.boundClose) {
        thankYouCloseBtn.dataset.boundClose = 'true';
        thankYouCloseBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const closeX = modal.querySelector('.jdgm-write-review-modal__close-btn');
          if (closeX) closeX.click();
          else modal.remove();
        }, true);
      }
      return; // Do not apply compact review form logic when on Thank You page
    }

    // 1. Prevent sections from shifting off-screen horizontally
    const sections = modal.querySelector('.jdgm-write-review-modal__sections');
    if (sections && sections.style.transform !== 'none') {
      sections.style.transform = 'none';
    }

    // 2. Ensure compact body is visible and active
    const compactBody = modal.querySelector('.jdgm-write-review-modal__compact-body');
    if (compactBody) {
      if (!compactBody.classList.contains('is-active')) {
        compactBody.classList.add('is-active');
      }

      // 3. Inject product photo right above the product title in the compact body
      const titleEl = compactBody.querySelector('.jdgm-write-review-modal__product-title');
      if (titleEl && !compactBody.querySelector('.jdgm-modal-product-img-wrap')) {
        const modalImg = modal.querySelector('.jdgm-write-review-modal__product-image img')?.src;
        const reviewWidget = document.getElementById('judgeme_product_reviews');
        let prodImg = modalImg || reviewWidget?.getAttribute('data-product-image') || 
                      document.querySelector('.pdp-gallery-main img, .product-media img')?.src || '';
        if (prodImg.startsWith('//')) prodImg = 'https:' + prodImg;
        if (prodImg) {
          const wrap = document.createElement('div');
          wrap.className = 'jdgm-modal-product-img-wrap';
          wrap.innerHTML = `<img src="${prodImg}" alt="Producto" class="jdgm-modal-product-img" />`;
          titleEl.insertAdjacentElement('beforebegin', wrap);
        }
      }
    }

    // 4. Ensure close "X" button is visible and accessible
    const closeBtn = modal.querySelector('.jdgm-write-review-modal__close-btn');
    if (closeBtn) {
      closeBtn.style.display = 'block';
      closeBtn.style.opacity = '1';
    }

    // 5. Transform back button into CANCELAR and close modal cleanly on click
    const backBtn = modal.querySelector('.jdgm-write-review-modal__nav-btn-back, .jdgm-write-review-modal__btn--back');
    if (backBtn && backBtn.textContent !== 'CANCELAR') {
      backBtn.textContent = 'CANCELAR';
      if (!backBtn.dataset.boundCancel) {
        backBtn.dataset.boundCancel = 'true';
        backBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (closeBtn) closeBtn.click();
          else modal.remove();
        }, true);
      }
    }
  }

  function hookModalPrototype() {
    if (window.jdgm && window.jdgm._WriteReviewModal && !window.jdgm._WriteReviewModal.__picaraHooked) {
      window.jdgm._WriteReviewModal.__picaraHooked = true;

      // Force modal to always start directly on page 2 (compact single step)
      window.jdgm._WriteReviewModal.prototype._determineStartingPage = function() {
        this.rating = this.rating || 5;
        return 2;
      };

      // Intercept showModalPage to handle single-step and thank you transitions
      const origShowModalPage = window.jdgm._WriteReviewModal.prototype.showModalPage;
      window.jdgm._WriteReviewModal.prototype.showModalPage = function(pageNumber, retryCount, options) {
        let targetPage = pageNumber;
        if (targetPage === 1 || targetPage === null || targetPage === undefined) {
          targetPage = 2;
        }

        const isThankYou = (this.pageNumbers && targetPage === this.pageNumbers.thankYou) || 
                           (targetPage >= 4 && !this._compactMode);

        const res = origShowModalPage.call(this, targetPage, retryCount, options);

        if (this.$modal) {
          if (isThankYou) {
            this.$modal.addClass('jdgm-write-review-modal--thank-you');
          } else {
            this.$modal.removeClass('jdgm-write-review-modal--thank-you');
          }
        }

        if (this.$modalSections) {
          this.$modalSections.css('transform', 'none');
        }

        setTimeout(() => {
          if (this.$modalSections) {
            this.$modalSections.css('transform', 'none');
          }
          applySingleStepAdjustments(this.$modal ? this.$modal[0] : document.querySelector('.jdgm-write-review-modal'));

          if (!isThankYou && this.$modal) {
            // Preselect 5 stars if not already selected
            const star5 = this.$modal.find('.jdgm-write-review-modal__compact-body .jdgm-star[data-alt="5"]');
            if (star5.length && !star5.hasClass('jdgm--on')) {
              star5.click();
            }
          }
        }, 20);

        return res;
      };
    }
  }

  function formatJudgeMeSummaryScore() {
    const widget = document.getElementById('judgeme_product_reviews');
    if (!widget) return;
    const widgInner = widget.querySelector('.jdgm-rev-widg');
    if (!widgInner) return;

    const rawCount = widgInner.getAttribute('data-number-of-reviews') || widget.getAttribute('data-number-of-reviews');
    const countNum = parseInt(rawCount, 10);
    if (!isNaN(countNum) && countNum === 0) {
      return;
    }

    const summary = widgInner.querySelector('.jdgm-rev-widg__summary');
    if (!summary) return;

    const avgEl = summary.querySelector('.jdgm-rev-widg__summary-average');
    if (avgEl) {
      const rawRating = widgInner.getAttribute('data-average-rating') || widget.getAttribute('data-average-rating') || '5.00';
      const ratingNum = parseFloat(rawRating) || 5.0;
      const formattedScore = ratingNum.toFixed(1);
      const scoreText = formattedScore + ' DE 5.0';

      if (avgEl.getAttribute('data-picara-score') !== formattedScore || avgEl.textContent.trim() !== scoreText) {
        avgEl.setAttribute('data-picara-score', formattedScore);
        avgEl.textContent = scoreText;
      }
    }

    const summaryText = summary.querySelector('.jdgm-rev-widg__summary-text');
    if (summaryText) {
      const rawCount = widgInner.getAttribute('data-number-of-reviews');
      const countNum = parseInt(rawCount, 10);
      if (!isNaN(countNum) && countNum > 0) {
        const expectedCountText = 'Basado en ' + countNum + (countNum === 1 ? ' reseña' : ' reseñas');
        if (!summaryText.textContent.includes(expectedCountText)) {
          const checkmark = summaryText.querySelector('.jdgm-verified-checkmark');
          const checkmarkHtml = checkmark ? checkmark.outerHTML : '<img class="jdgm-verified-checkmark" src="https://public-images.judge.me/judgeme/logos/verified-checkmark.svg" alt="Verified Checkmark">';
          summaryText.innerHTML = expectedCountText + ' ' + checkmarkHtml;
        }
      }
    }
  }

  const hookTimer = setInterval(hookModalPrototype, 30);
  const summaryTimer = setInterval(formatJudgeMeSummaryScore, 50);
  setTimeout(() => {
    clearInterval(hookTimer);
    clearInterval(summaryTimer);
  }, 15000);

  // Fallback DOM Observer for continuous markup enforcement
  const observer = new MutationObserver(() => {
    const modal = document.querySelector('.jdgm-write-review-modal');
    if (modal) {
      applySingleStepAdjustments(modal);
    }
    formatJudgeMeSummaryScore();
  });

  const targetNode = document.body || document.documentElement;
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }
}


// ----------------------------------------------------
// APPLICATION INITIALIZATION ENTRY POINT
// ----------------------------------------------------
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initApp);
} else {
  initApp();
}

